import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'
import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, saveGridLayout } from '../common/utils';
import RoutemapTransitAction from './RoutemapTransitAction.js'
import RoutemapenrouteAction from './routemapenroute.js';
import moment from "moment";
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Filter from '../../assets/icons/filters.svg'
import redirectURL from "../redirectURL";
import MainCounters from './mainCounters.js'
import ViewMap from './ViewMap';
import TransitDelay from './TransitDelay';
import EnrouteException from './EnrouteException';
// import Overspeeding from './Overspeeding';
// import NightDriving from './NightDriving';
import LoadingException from './LoadingException';
import UnloadingException from './UnloadingException';
import DrawMap from '../common/drawmap';
import RoutemapAction from './routemapActionComponent.js';
import RouteNightDrivemap from './routenightdrivemap.js';
import NoGPS from './NoGPS.js';
import NoGPSMap from './NoGPSMap.js';
import ForceClose from './forceClose.jsx';
import CourierActions from '../layouts/courierActions.js';

import ConsignmentActions from './ConsignmentActionsComponent';
import ShipmentLegs from "../layouts/shipmentlegs.js";
import AddDealerConsignments from "./addDealerConsignments.js";




var map = ''
function Consignments() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    const user = useMemo(() => JSON.parse(decode(localStorage.getItem("k"))), []);

    const gridApi = useRef();
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([])
    var [filterToggle, setFilterToggle] = useState(false)
    var [key, setKey] = useState('')
    const [gridColumnState, setGridColumnState] = useState([]);
    const [overly, setOverlay] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [reasonForceClose, setReasonForceClose] = useState("");
    const [filterCities, setFilterCities] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [searchCity, setSearchCity] = useState({ label: '', value: '' });
    const [searchState, setSearchStates] = useState({ label: '', value: '' });
    const [searchTransporters, setSearchTransporters] = useState({ label: '', value: '' });
    const [searchConsigner, setSearchConsigner] = useState([{ label: 'All', value: 'all' }]);
    const [consignersList, setConsignersList] = useState([]);
    const [searchConsignee, setSearchConsignee] = useState([{ label: 'All', value: 'all' }]);
    const [movementtype, setMovementtype] = useState({ label: '', value: '' });
    const [searchValue, setSeachValue] = useState('');
    const [searchType, setSearchType] = useState({ label: '', value: '' });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [tabName, setTabName] = useState({ label: "Active", value: "active" });
    const [counter, setCounter] = useState({ label: "Consignments", value: "consignments" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [basicTitle, setBasicTitle] = useState('');
    const [basicType, setBasicType] = useState('');
    const [maptruckno, setMaptruckno] = useState('');
    const [deptcode, setDeptcode] = useState('');
    const [sliderRouteTranslate, setSliderRouteTranslate] = useState('');
    const [showDiv, setShowDiv] = useState('');
    const [mapinfo, setMapinfo] = useState({});
    const [dealer, setDealer] = useState('');
    const [consignment_code, setConsignment_code] = useState('');
    const [routeTruck, setRouteTruck] = useState({});
    const [leg_no, setLeg_no] = useState(0);
    const [tolls, setTolls] = useState([]);
    const [devation_flag, setDevation_flag] = useState(false);
    const [sliderCreateConsignmentTranslate, setSliderCreateConsignmentTranslate] = useState("show-n")
    var [selected_row, setselected_row] = useState({});
    const [showAddForm, setshowAddForm] = useState("");
    var [tabActive, settabActive] = useState('ftl')

    const [manualUploadDetails, setmanualUploadDetails] = useState({
        lr_no: "",
        consignee_name: "",
        invoice_no: "",
        no_of_boxes: "",
        destination_pincode: "",
        destination_city: "",
      });

    const [formData, setFormData] = useState({
        truck_no: '',
        plant_code: '',
        plant_name: '',
        grno_consignment_code: '',
        invoice_no: '',
        driver_name: '',
        driver_mobile_num: '',
        mobile_operator: '',
        transit_days: '',
        consignee_code: '',
        consignee_name: '',
        invoice_date: '',
        gate_out_time: '',
        show: false,
        basicType: '',
        basicTitle: '',
        sliderCreateConsignmentTranslate: '',
        loadshow: 'show-n',
        overly: 'show-n',
    });
    const [tabOptions, setTabOptions] = useState([
        { label: "Active", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "All", value: "all" }
    ])
    const [counterOptions, setCounterOptions] = useState([
        { label: "Consignments", value: "consignments" },
        { label: "Transit Delays", value: "transit_delays" },
        { label: "No GPS Available", value: "no_gps_data" },
        { label: "No GPS Available Lifetime", value: "no_gps_data_lifetime" },
        // { label: "Overspeeding", value: "overspeeding" },
        // { label: "Night Driving", value: "night_driving" },
        { label: "Stoppages", value: "stoppages" },
        { label: "Accidents", value: "accidents" },
        { label: "Trip Deviations", value: "trip_deviations" },
        { label: "Loading Delay", value: "loading_delay" },
        { label: "Unloading Delay", value: "unloading_delay" }
    ]);

    var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [rownode, setRownode] = useState([]);
    var [mapDetails, setMapDetails] = useState([]);
    const [activeTrips, setActiveTrips] = useState({
        all: [],
        transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [completedTrips, setCompletedTrips] = useState({
        all: [],
        transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [allTrips, setAllTrips] = useState({
        all: [],
        transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [modalloadData, setModalLoadData] = useState([])
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [previousData, setPreviousData] = useState([])
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [countersActive, setCountersActive] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersCompleted, setCountersCompleted] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersAll, setCountersAll] = useState({
        consignments: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const transitdelaycols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapTransitAction,
                            params: {
                                onShowTransitRouteMap: onShowTransitRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Leg End Time", field: "leg_end_eta",
            width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Exp. Leg Distance (KM)",
            field: "leg_expected_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.leg_expected_distance);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Actual Leg Distance Covered (KM)",
            field: "actual_leg_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                    return Math.round(params.data.actual_leg_distance);
                }
                else {
                    return 0;
                }
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exp. Distance from Trip Start(KM)",
            field: "expected_distance_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                    return Math.round(params.data.expected_distance_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }

        },
        {
            headerName: "Actual Distance from Trip Start (KM)",
            field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                    return Math.round(params.data.actual_distance_traveled_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },

        {
            headerName: "Google Distance from Start (KM)",
            field: "actual_start_to_leg_google_distance",
            width: 140,
            resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },
        {
            headerName: "GPS Data Available",
            field: "no_gps_data",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.no_gps_data == 1) {
                    return "Not Available";
                }
                if (params.data.no_gps_data == 0) {
                    return "Available";
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },


        {
            headerName: "Trip Completed",
            field: "trip_completed",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.trip_completed == 1) {
                    return "Yes";
                }
                if (params.data.trip_completed == 2) {
                    return "";
                }
                if (params.data.trip_completed == 0) {
                    return "";
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const stoppagescols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapenrouteAction,
                            params: {
                                onShowEnrouteRouteMap: onShowEnrouteRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
        },
        {
            headerName: "Break Start",
            field: "stoppage_start_time",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.stoppage_start_time != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.stoppage_start_time)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break End",
            field: "reset_datetime",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.reset_datetime != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.reset_datetime)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exception Closed On",
            field: "modified_date",
            width: 220,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {

                    if (params.data.modified_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break Time",
            field: "elaped_time_from_last_moved_seconds",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {
                    var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
                    if (typeof params.data.reset_datetime == 'undefined') {
                        var edate = moment.parseZone().format("x");
                    }
                    else {
                        var edate = moment.parseZone(params.data.reset_datetime).format("x");
                    }
                    var diff = (edate - sdate) / 1000;
                    return secondsToString(diff);
                }
                else {
                    return '';
                }
            }
        }
    ]
    const overspeedcols = [
        {
            headerName: "", field: "_id",
            width: 50,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapAction,
                            params: {
                                onShowRouteMap: onShowRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            resizable: true
        },
        { headerName: "Truck No", field: "truck_no", filter: true, resizable: true },
        { headerName: "Speed (km/h)", field: "speed", filter: true, resizable: true },
        {
            headerName: "Reported At", field: "first_instance", filter: true, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
    ]
    const nightdrivingcols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RouteNightDrivemap,
                            params: {
                                onShowNightDriveRouteMap: onShowNightDriveRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true
        },
        { headerName: "Truck No", field: "truck_no", width: 150, resizable: true },
        {
            headerName: "Traveled From", field: "first_instance", width: 180, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
        {
            headerName: "Traveled Until", field: "recent_instance", resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.recent_instance);
            }
        },
        {
            headerName: "Distance Traveled (km)", field: "distance_from_first_instance", width: 180,
            resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.distance_from_first_instance)
            }
        }
    ]
    const unloadingcols = [
        {
            headerName: "From Date",
            field: "from_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                // console.log("child params ", params)
                if (params.data.from_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.from_date);
                }
                else {
                    return "NA"
                }

            }
        },
        {
            headerName: "To Date",
            field: "to_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.to_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.to_date);
                }
                else {
                    return "NA"
                }
            }
        },
        {
            headerName: "Unloading Time",
            field: "unloading_time",
            width: 180,
        }
    ]
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        pivot: false,
    }
    let gridLegColumns = [];
    const columnDef = [
        {
            headerName: "Plant Location Code",
            field: "plant_code",
            editable: true,
            cellStyle: params => {
                if (params.data.plant_code == undefined || params.data.plant_code == "" || !plantData.some(e => e.consigner_code == params.data.plant_code)) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "FO Number",
            field: "fo_number",
            editable: true,
            cellStyle: params => {
                if (params.data.fo_number == undefined || params.data.fo_number == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
                if (params.data.hasOwnProperty("exists") && params.data.exists == 1) {
                    return {
                        "backgroundColor": '#ffcc00'
                    };
                }
            }
        },
        {
            headerName: "Order Number",
            field: "order_number",
            editable: true,
            cellStyle: params => {
                if (params.data.order_number == undefined || params.data.order_number == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
                if (params.data.hasOwnProperty("exists") && params.data.exists == 1) {
                    return {
                        "backgroundColor": '#ffcc00'
                    };
                }
            }
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            editable: true,
            cellStyle: params => {
                if (params.data.invoice_date == undefined || params.data.invoice_date == "" || (!moment(params.data.invoice_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Vehicle No",
            field: "vehicle_no",
            editable: true,
            cellStyle: params => {
                if (params.data.vehicle_no == undefined || params.data.vehicle_no == "") {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Vehicle Type",
            field: "vehicle_type",
            editable: true
        },
        {
            headerName: "Transporter Code",
            field: "transporter_code",
            editable: true,
            cellStyle: params => {
                if (params.data.transporter_code == undefined || params.data.transporter_code == "" || !transporters.some(e => e.transporter_code == params.data.transporter_code)) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            editable: true
        },
        {
            headerName: "Dealer Code",
            field: "dealer_code",
            editable: true,
            cellStyle: params => {
                if (params.data.dealer_code == undefined || params.data.dealer_code == "" || !dealers.some(e => e.consignee_code == params.data.dealer_code)) {

                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Dealer Name",
            field: "dealer_name",
            editable: true
        },
        {
            headerName: "Dealer City",
            field: "dealer_city",
            editable: true
        },
        {
            headerName: "Quantity",
            field: "quantity",
            editable: true,
            cellStyle: params => {
                if (params.data.quantity == undefined || params.data.quantity == "" || isNaN(params.data.quantity)) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Gross Weight (VU)",
            field: "gross_weight",
            editable: true
        },
        {
            headerName: "Gross Volume (VU)",
            field: "gross_volume",
            editable: true
        },
        {
            headerName: "Execution Date",
            field: "execution_date",
            editable: true,
            cellStyle: params => {
                if (params.data.execution_date == undefined || params.data.execution_date == "" || (!moment(params.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Expected Delivery Date",
            field: "expected_date",
            editable: true,
            cellStyle: params => {
                if (params.data.expected_date == undefined || params.data.expected_date == "" || (!moment(params.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        },
        {
            headerName: "Expected Return To Plant Date",
            field: "expected_return_to_plant_date",
            editable: true,
            cellStyle: params => {
                if (params.data.execution_date == undefined || params.data.execution_date == "" || (!moment(params.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                    return {
                        "backgroundColor": '#c85f62'
                    };
                }
            }
        }
    ]
    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Receieved",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const columnDefs2 = [
        {
            headerName: "",
            field: "_id",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "transit_delay",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: TransitDelay,
                            params: {
                                onShowTransitData: onShowTransitData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "no_gps_data",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPS,
                            params: {
                                onShowNoGPSData: onShowNoGPSData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "enroute_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: EnrouteException,
                            params: {
                                onShowStoppagesData: onShowStoppagesData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "overspeeding_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: Overspeeding,
        //                     params: {
        //                         onShowOverspeedingData: onShowOverspeedingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        // {
        //     headerName: "",
        //     field: "nightdriving_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: NightDriving,
        //                     params: {
        //                         onShowNightDrivingData: onShowNightDrivingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "loading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: LoadingException,
                            params: {
                                onShowLoadingData: onShowLoadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "unloading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: UnloadingException,
                            params: {
                                onShowUnloadingData: onShowUnloadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "Consignment Code",
            field: "consignment_code"
        },
        {
            headerName: "Status",
            field: "status",
            valueGetter: function (params) {
                if (params.data.status == 1) {
                    return "Open";
                }
                else if (params.data.status == 2) {
                    return "InTransit";
                }
                else if (params.data.status == 3) {
                    return "Near Dealer";
                }
                else if (params.data.status == 4) {
                    return "Reached Dealer";
                }
                else if (params.data.status == 5) {
                    return "Left Dealer";
                }
                else if (params.data.status == 6) {
                    return "Force Closed";
                }
                else if (params.data.status == 7) {
                    return "Proximity Trip Closure";
                }
                else if (params.data.status == 8) {
                    return "Force Closed";
                }
                else {
                    return "NA";
                }
            }
        },
        {
            headerName: "Plant Location Code",
            field: "consigner_code"
        },
        {
            headerName: "FO Number",
            field: "fo_number"
        },
        {
            headerName: "Order Number",
            field: "order_number"
        },
        {
            headerName: "Quantity",
            field: "quantity"
        },
        {
            headerName: "Gross Weight (VU)",
            field: "gross_weight"
        },
        {
            headerName: "Gross Volume (VU)",
            field: "gross_volume"
        },
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            valueGetter: function (params) {
                if (params.data.invoice_time != undefined && params.data.invoice_time != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time)
                }
            }
        },
        {
            headerName: "Vehicle No.",
            field: "truck_no"
        },
        {
            headerName: "Vehicle Type",
            field: "truck_type"
        },
        {
            headerName: "Gate In Time",
            field: "gate_in_time"
        },
        {
            headerName: "Transporter Code",
            field: "transporter_code"
        },
        {
            headerName: "Transporter Name",
            field: "transporter_name"
        },
        {
            headerName: "Consigner Code",
            field: "consigner_code"
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code"
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name"
        },
        {
            headerName: "Consignee Zone",
            field: "consignee_zone"
        },
        {
            headerName: "Consignee Area",
            field: "consignee_area"
        },
        {
            headerName: "Consignee City",
            field: "consignee_city"
        },
        {
            headerName: "Consignee State",
            field: "consignee_state"
        },
        {
            headerName: "Dealer Distance from Plant",
            field: "dealer_distance_from_plant"
        },
        {
            headerName: "Execution Date",
            field: "execution_date",
            valueGetter: function (params) {
                if (params.data.execution_date != undefined && params.data.execution_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.execution_date)
                }
            }
        },
        {
            headerName: "Expected Delivery Date",
            field: "expected_date",
            valueGetter: function (params) {
                if (params.data.expected_date != undefined && params.data.expected_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_date)
                }
            }
        },
        {
            headerName: "Expected Return To Plant Date",
            field: "expected_return_to_plant_date",
            valueGetter: function (params) {
                if (params.data.expected_return_to_plant_date != undefined && params.data.expected_return_to_plant_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_return_to_plant_date)
                }
            }
        },
        {
            headerName: "Created Date",
            field: "created_date",
            valueGetter: function (params) {
                if (params.data.created_date != undefined && params.data.created_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                }
            }
        },
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ForceClose,
                            params: {
                                onShowForceCloseModal: onShowForceCloseModal
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        }
    ];
    const isDelivered = window.location.pathname.includes("completedconsignments")
    // let showdistance = (this.props.match.path == "/activecosnignments")
			// || (this.props.match.path == "/prtconsignments")
			// || (this.props.match.path == "/tnpconsignments")) 
            // ? false : true;
    const columnwithDefs =
			[
				// {
				// 	headerName: "Actions",
				// 	field: "_id",
				// 	colId: "_id",
				// 	width: 40,
				// 	pinned: 'left',
				// 	filter: false, resizable: true,
				// 	// headerCheckboxSelection: checkboxSelectionval,
				// 	//headerCheckboxSelectionFilteredOnly: true,
				// 	checkboxSelection: true

				// },
                {
                    headerName: "",
                    field: "_id",
                    width: 50,
                    pinned: "left",
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                return {
                                    component: CourierActions,
                                    params: {
                                        onShowCourierTrack: onShowCourierTrack
                                    }
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                },
                {
                    headerName: "View Route",
                    field: "view_route",
                    width: 50,
                    pinned: "left",
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data.view_route != null && param.data.view_route != undefined) {
                                return {
                                    component: ViewMap,
                                    params: {
                                        onClickShowRoute: onClickShowRoute
                                    }
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                },
                // {
                //     headerName: "Transit Delay",
                //     field: "transit_delay",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: TransitDelay,
                //                     params: {
                //                         onShowTransitData: onShowTransitData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "GPS Data",
                //     field: "no_gps_data",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: NoGPS,
                //                     params: {
                //                         onShowNoGPSData: onShowNoGPSData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "Enroute Stoppages",
                //     field: "enroute_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: EnrouteException,
                //                     params: {
                //                         onShowStoppagesData: onShowStoppagesData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "loading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: LoadingException,
                //                     params: {
                //                         onShowLoadingData: onShowLoadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "unloading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: UnloadingException,
                //                     params: {
                //                         onShowUnloadingData: onShowUnloadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
				// 	pinned: "left",
				// 	headerName: 'Deviation',
				// 	colId: 'deviation_identified',
				// 	field: 'deviation_identified',
				// 	width: 40,
				// 	cellStyle: { color: "#464855", fontWeight: "500", display: "flex", alignItems: "center" },
				// 	// cellRenderer: 'kpiDeviationActions',
				// 	// valueGetter: function (params) {
				// 	// 	if(params.data.deviation_identified != undefined && params.data.deviation_identified != null && params.data.deviation_identified != ""){
				// 	// 		if ([1,1.0,"1","1.0"].includes(params.data.deviation_identified))
				// 	// 		{
				// 	// 		   return "Deviated";
				// 	// 	   }
				// 	// 	   else {
				// 	// 		   return "Not Deviated";
				// 	// 	   }
				// 	// 	}else{
				// 	// 		return "Not Deviated";
				// 	// 	}
				// 	// }
				// },
                // {
                //     headerName: "Shipment Legs",
                //     field: "shipmentlegs",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: ShipmentLegs,
                //                     params: {
                //                         onClickShowShipmentLegs: onClickShowShipmentLegs
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
				// {
				// 	headerName: "View Route",
				// 	field: "_id",
				// 	colId: "_id",
				// 	width: 40,
				// 	pinned: 'left',
				// 	cellRenderer: ConsignmentActions,
				// 	filter: false, resizable: true

				// },

				// {
				// 	headerName: "Transit Delay",
				// 	field: "transit_delay",
				// 	colId: "transit_delay",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
				// 	cellRendererSelector: function (params) {
				// 		if (params.data.transit_delay == 1) {
				// 			var rendComponent = {
				// 				component: 'kpiTransitDelayActions'
				// 			};
				// 			return rendComponent
				// 		}
				// 		else {
				// 			rendComponent = {
				// 				component: 'notransit'
				// 			};
				// 			return rendComponent
				// 		}
				// 	},
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Gps Data",
				// 	field: "no_gps_data",
				// 	colId: "no_gps_data",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {
					// 	var comp = 'gps';
					// 	if (params.data.no_gps_data == 0 && params.data.no_gps_data_lifetime == 1) {
					// 		comp = 'noGpsLifetime'

					// 	}
					// 	else if (params.data.no_gps_data == 1) {
					// 		comp = 'nogps'
					// 	}

					// 	else if (params.data.no_gps_data == 0) {
					// 		comp = 'gps'

					// 	}
					// 	var rendComponent = {
					// 		component: comp
					// 	};
					// 	return rendComponent
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Overspeed",
				// 	field: "overspeeding_exception",
				// 	colId: "overspeeding_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {
					// 	if (params.data.overspeeding_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiActions'
					// 		};
					// 		return rendComponent
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'nooverspeed'
					// 		};
					// 		return rendComponent
					// 	}
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Night Drive",
				// 	field: "nightdriving_exception",
				// 	colId: "nightdriving_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: true,
					// hide: hideonlyPRT,
					// cellRendererSelector: function (params) {
					// 	//console.log("Except ",params.data.nightdriving_exception)
					// 	//console.log("Consignemnt code ", params.data.consignment_code)
					// 	if (params.data.nightdriving_exception != undefined && params.data.nightdriving_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiNightDriveActions'
					// 		};
					// 		return rendComponent
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'nonightdrive'
					// 			//component: 'kpiNightDriveActions'
					// 		};
					// 		return rendComponent
					// 	}
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Loading Delay",
				// 	field: "loading_delay_exception",
				// 	colId: "loading_delay_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// hide: hideonlyPRT,
					// cellRendererSelector: function (params) {
					// 	var rendComponent = {
					// 		component: 'kpiLoadingDelayActions'
					// 	};
					// 	return rendComponent;
					// },
				// 	filter: false, resizable: true
				// },
				// {
				// 	headerName: "Unloading Delay",
				// 	field: "unloading_delay_exception",
				// 	colId: "unloading_delay_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// hide: hideonlyCol,
					// cellRendererSelector: function (params) {
					// 	if (params.data.unloading_delay_exception != undefined && params.data.unloading_delay_exception == 1) {
					// 		var rendComponent = {
					// 			component: 'kpiUnLoadingDelayActions'
					// 		};
					// 		return rendComponent;
					// 	}
					// 	else {
					// 		var rendComponent = {
					// 			component: 'kpiUnLoadingDelayActions'
					// 		};
					// 		return rendComponent;
					// 	}

					// },
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Enroute Stoppages",
				// 	field: "enroute_exception",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
					// cellRendererSelector: function (params) {

					// 	var rendComponent = {
					// 		component: 'kpiEnrouteStoppagesActions'
					// 	};
					// 	return rendComponent

					// },
				// 	filter: false, resizable: true,
				// },
				
				// {
				// 	headerName: "Day Wise Distance Trip",
				// 	field: "day_wise_distance_trip",
				// 	colId: "day_wise_distance_trip",
				// 	width: 40,
				// 	pinned: 'left',
				// 	pivot: false,
				// 	hide: true,
				// 	cellRenderer: 'kpiDayWiseDistanceActions',
				// 	filter: true, resizable: true
				// },
				// {
				// 	headerName: "Tolls",
				// 	field: "toll_details",
				// 	// colId: "breaks_at_tolls",
				// 	width: 40,
				// 	pinned: 'left',
				// 	filter: true,
				// 	resizable: true,
				// 	hide: showForDeliveryPrt,
				// 	cellRenderer: (params) => `<img style="height: 25px; width: 24px" src=${tollImg} />`,			

				// },
				/*	{
						headerName: "Actions",
						field: "comment_exists",
						//colId: "_id",
						width: 40,
						pinned: 'left',
						cellRenderer:'commentActions',
						filter: true,
						resizable: true,
						hide: (this.state.tnpReturnConsignmentsVisibilty)?true:false
	
					},
					{
						headerName: "",
						field: "tickets",
						//colId: "_id",
						width: 40,
						pinned: 'left',
						filter: true,
						resizable: true,
						hide: (this.state.tnpReturnConsignmentsVisibilty)?true:false,
						cellRendererSelector:function(params){
	
							var rendComponent = {
								component: 'Consignmenttickets'
							};
							return rendComponent
	
						},
	
					},*/
				/*			filter: true,
						resizable: true,
						hide: hideTNPconsignment,
						cellRenderer:function(params){
							return "<i class='fa fa-file'><i>"
						},
	
					},
					// {
					// 	headerName: "Actions",
					// 	field: "_id",
					// 	colId: "_id",
					// 	width: 40,
					// 	pinned: 'left',
					// 	resizable: true,
					// 	cellRenderer : "SegmentAction"
	
					// },
	
					{
						pinned:"left",
						headerName : "",
						field:"delete",
						width:40,
						resizable : true,
						editable : false,
						cellRenderer:function(params){
							if(params.data.consigner_code == "SMG")
							{
								return '<i class="icofont icofont-ui-delete"></i>';
							}
						},
						hide:hideDeleteOpt
					},*/

				// {
				// 	headerName: "Invoice No",
				// 	field: "invoice_no",
				// 	pinned: 'left',
				// 	width: 100,
				// 	resizable: true,
				// 	// hide:hideTNPconsignment,
				// 	// comparator: dateComparator,
				// 	valueGetter: function (params) {
				// 		if (params.data.invoice_no != '' && params.data.invoice_no != undefined) {
				// 			return parseInt(params.data.invoice_no).toString();
				// 		}
				// 		else {
				// 			return "";
				// 		}
				// 	},
				// },

				// {
				// 	headerName: "",
				// 	field: "shipmentlegs",
				// 	width: 50,
				// 	pinned: 'left',
				// 	cellRenderer:ShipmentLegs,
				// 	filter: false,resizable: true
					
				// },
				{
					headerName: "Truck No",
					field: "truck_no",
					width: 120,
					pinned: "left",
					filter: "agSetColumnFilter",
					resizable: true
				},
				{
					headerName: "Status",
					field: "status",
					width: 120,
					pinned: 'left',
					// hide : hideStatus,
					filter: "agSetColumnFilter",
					resizable: true,
                    valueFormatter: (params) => {
                        const statusMap = {
                            1: "At Plant",
                            2: "In Transit",
                            3: "Near Destination",
                            4: "Reached Dealer",
                            5: "Left Dealer",
                            6: "Force Closure",
                            7: "Provision"
                        };
                        return statusMap[params.value] || "Not Available";
                    }
					// valueGetter: (params) => {
					// 	//console.log("GPS ", params.data.gps_data_available);
					// 	if (params.data.status == 1) {
					// 		return "Inside Plant"
					// 	}
					// 	else if (params.data.status == 2) {
					// 		return "In Transit"
					// 	}
					// 	else if (params.data.dest_geofence_id != undefined && screen_type == "LOG-PRT") {
					// 		if (screen_url != "/prtconsignments") {
					// 			return "Reached Plant Gate";
					// 		}
					// 	}
					// 	else if (params.data.status == 3) {
					// 		return "Near Destination"
					// 	}
					// 	else if (params.data.status == 4) {
					// 		return "Reached Destination"
					// 	}

					// 	else if (params.data.status == 5) {
					// 		return "Trip Completed"
					// 	}
					// 	else if (params.data.status == 6) {
					// 		return "Force Closed"
					// 	}
					// 	else if (params.data.status == 7) {
					// 		return "Proximity Trip Closure"
					// 	}
					// 	else if (params.data.status == 8) {
					// 		return "Crossdock"
					// 	}
					// 	else if (params.data.status == 9) {
					// 		return "Trip Completed"
					// 	}
					// 	else {
					// 		return ""
					// 	}

					// }
				},
				{
					headerName: "Invoice Time",
					field: "invoice_time",
					width: 180,
					pinned: 'left',
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
						}
						else {
							return "NA";
						}
					},
					// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
				},{
					// headerName: "Trip Started On" ,
					headerName: "Dispatch Date" ,
					field: "gate_out_time",
					width: 150,
					pinned: 'left',
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.gate_out_time != '' && params.data.gate_out_time != undefined && params.data.gate_out_time !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
						}
						else {
							return "NA";
						}
					},
				
				},
				{
					headerName: "Shipment Id" ,
					field: "shipment_id",
					width: 150,
					cellRenderer: '', resizable: true,
					hide:true,
					
				},
                {
					headerName: "Source" ,
					field: "source",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Truck Seal No" ,
					field: "truck_seal_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Entity" ,
					field: "entity",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Truck Type" ,
					field: "truck_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
				
				
				// {
				// 	headerName: "Truck Starting Point",
				// 	field: "truck_starting_point",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	hide: last_consignment_zone,
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName: "GR No",
				// 	field: "consignment_code",
				// 	//colId : "consignment_code",
				// 	width: 120,
				// 	editable: false,
				// 	filter: "agSetColumnFilter", resizable: true,
				// 	//cellRenderer : "agGroupCellRenderer"
				// },
				/*	{
						headerName: "VIN No(s)",
						field: "vin_list",
						width: 120,
						pinned: "left",
						editable: false,
						resizable: true,
						hide: hideVinsbvh
					},
					{
						headerName: "SBVH Code",
						field: "sbvh",
						width: 120,
						pinned: "left",
						editable: false,
						resizable: true,
						hide: hideVinsbvh
					},*/
				
				// {
				// 	headerName: "Original ETA",
				// 	field: "expected_trip_end",
				// 	id: "expected_trip_end",
				// 	width: 120,
				// 	//pinned: 'left',
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		if (params.data.expected_trip_end != "" && params.data.expected_trip_end != undefined && params.data.expected_trip_end != null) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end);
				// 		}
				// 		else {
				// 			return "";
				// 		}


				// 	},
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// },
				// {
				// 	headerName: "Revised ETA",
				// 	field: "revised_trip_end",
				// 	width: 120,
				// 	//pinned: 'left',
				// 	resizable: true,
				// 	// cellClass : "dateFormat",
				// 	valueGetter: function (params) {
				// 		//console.log(" ETA ", params.data)
				// 		if (params.data.revised_trip_end == '' || params.data.revised_trip_end == undefined) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end);
				// 		}
				// 		else {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end);
				// 		}

				// 	},
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	cellClass: function (params) {
				// 		let hourDifference = 0;
				// 		if (params.data.revised_trip_end && params.data.expected_trip_end) {
				// 			let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
				// 			let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
				// 			hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
				// 			//console.log("diff= ", params.data.consignment_code, hourDifference);
				// 		} else {
				// 			//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
				// 		}

				// 		if (hourDifference >= 1) {
				// 			return 'bgColorDangerMedium'
				// 		}

				// 		if (hourDifference <= -1) {
				// 			return 'bgColorSuccessMedium'
				// 		}
				// 		else {
				// 			return ''
				// 		}
				// 	}
				// },
				// {
				// 	headerName: "Transit Delay (Days)",
				// 	field: "consignment_code",
				// 	width: 120,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '',
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		var expected = params.data.expected_trip_end;
				// 		if (params.data.revised_trip_end == '' || params.data.revised_trip_end == undefined) {
				// 			var revised = params.data.expected_trip_end;
				// 		}
				// 		else {
				// 			var revised = params.data.revised_trip_end;
				// 		}
				// 		//console.log("Exp ", expected)
				// 		//console.log("revised ", revised)
				// 		var s = moment.parseZone(expected).format("x");
				// 		var ed = moment.parseZone(revised).format("x");
				// 		//console.log("Exp ", s)
				// 		//console.log("revised ", ed)
				// 		var diff = (ed - s)
				// 		// console.log("Diff",diff/1000)
				// 		var days = secondsToDays(diff)
				// 		//console.log("Days ", Math.round(days/1000))
				// 		var totaldays = Math.round(days / 1000);
				// 		if (totaldays > 0) {
				// 			return totaldays;
				// 		}
				// 		else {
				// 			return 0;
				// 		}
				// 		//return Math.round(days/1000);

				// 	}
				// },
				
				// {
				// 	headerName: "Duration from Gate Out",
				// 	field: "duration_from_gate_out",
				// 	width: 170,
				// 	pinned: "left",
				// 	filter: true,
				// 	resizable: true,
				// 	hide: hideDuration,
				// 	valueGetter: function (params) {
				// 		if (params.data.gate_out_time != undefined &&
				// 			params.data.gate_out_time != "" &&
				// 			params.data.gate_out_time != null
				// 		) {
				// 			var gateout = new Date(params.data.gate_out_time);
				// 			var lastpacket = new Date();
				// 			var diff = lastpacket.getTime() - gateout.getTime();
				// 			var diffdate = new Date(diff);
				// 			var days = Math.floor(diff / (1000 * 60 * 60 * 24))
				// 			days = (days < 0) ? 0 : days;
				// 			return days + " Day(s) : " + diffdate.getHours() + " hours : " + diffdate.getMinutes() + " Minutes"
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	}
				// },

				{
					headerName: "Transporter Name",
					field: "transporter_name",
					width: 180,
					filter: "agSetColumnFilter",
					cellRenderer: '',
					resizable: true,
					valueGetter: function (params) {
						if (params.data.truck_no != "" && params.data.truck_no != "") {
							return params.data.transporter_name
						}
					}
				},
                {
					headerName: "Ewaybill Expiry Date" ,
					field: "ewaybill_expiry_date",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Vehicle Capacity" ,
					field: "vehicle_capacity",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Movement Type" ,
					field: "movement_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "LR No." ,
					field: "lr_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Invoice No." ,
					field: "invoice_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Number Of Boxes" ,
					field: "no_of_boxes",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination Pincode" ,
					field: "destination_pincode",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination City" ,
					field: "destination_city",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                


				// {
				// 	headerName: "Transporter Code",
				// 	field: "transporter_code",
				// 	width: 110,
				// 	filter: "agSetColumnFilter",
				// 	// hide: hideTransporterCode,
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (params.data.truck_no != "" && params.data.truck_no != "") {
				// 			return params.data.transporter_code
				// 		}
				// 	}
				// },

				{
					headerName: "Travel Status",
					field: "elaped_time_from_last_moved_seconds",
					width: 150,
					filter: "agSetColumnFilter",
					hide:isDelivered,
					// valueGetter: function (params) {
					// 	// console.log(window.location.pathname.includes("prtallconsignments"),"paathname")
					// 	try {
					// 		if (params.data.truck_no != "" && params.data.truck_no != "") {
					// 			if (params.data.elaped_time_from_last_moved_seconds != "" && params.data.elaped_time_from_last_moved_seconds != undefined) {
					// 				if(params.data.status==9 || params.data.status==6 ||  params.data.status==5){
					// 					return "Trip Closed"
					// 				}
					// 				return "Idle (" + secondsToDhms(params.data.elaped_time_from_last_moved_seconds) + ")";
					// 			}

					// 			else {
					// 				if (params.data.elaped_time_from_last_moved_seconds == "" && params.data.elaped_time_from_last_moved_seconds == undefined) {

					// 					return "";
					// 				}
					// 				else if (params.data.no_gps_data == 1) {
					// 					return "Not Active";
					// 				}
									
					// 				else if(window.location.pathname.includes("prtallconsignments") && (params.data.status==4)){
										
					// 					return "Delivered"
					// 				}
					// 				else if(window.location.pathname.includes("prtallconsignments") && params.data.status==5){
					// 					return "Trip Completed "
					// 				}
					// 				else if(params.data.status==9 || params.data.status==6){
					// 					return "Trip Closed"
					// 				}else if (params.data.status == 8 ) {
					// 					return "Crossdock"
					// 				}
					// 				else{
					// 					return "Running";
					// 				}
									
					// 			}
					// 		}
					// 	}
					// 	catch (e) {

					// 	}
					// }
				},

				{
					headerName: "Speed",
					field: "speed",
					width: 150,
					filter: "agSetColumnFilter",
					hide: isDelivered,
					valueGetter: function (params) {
						if (
							params.data.truck_no &&
							!['',null,undefined,"undefined"].includes(params.data.elaped_time_from_last_moved_seconds) &&
							params.data.status !== 9 &&
							params.data.status !== 6 &&
							params.data.status !== 5 &&
							['',null,undefined,"undefined"].includes(params.data.speed)
						) {
							return "0";
						}else{
							return params.data.speed
						}
					}
				}
				,

				{
					headerName: "Travelled Distance (KM)",
					field: "aprox_dist_travelled_from_start",
					width: 200,
					filter: "agSetColumnFilter",
					valueGetter: params => {
						let data = params.data.aprox_dist_travelled_from_start
						if (data == 0) {
							return 0
						}
						return data
						// console.log("params",params.data.aprox_dist_travelled_from_start)
					}
				},
				{
					headerName: "Last Packet Time",
					field: "timestamp",
					width: 180,
					hide:isDelivered,
					valueGetter: function (params) {
						return getHyphenDDMMMYYYYHHMM(params.data.timestamp)
					},
					comparator: dateComparator,
				},
				// {
				// 	headerName: "GPS Provider",
				// 	field: "truck",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	hide: showOnlyCol,
				// 	valueGetter: function (params) {
				// 		//console.log(params.data.transporter);
				// 		if (params.data.hasOwnProperty('truck')) {
				// 			if (params.data.truck.length > 0) {
				// 				return params.data.truck[0].actual_lspuser;
				// 			}
				// 		}

				// 	},
				// },				
				{
					headerName: "Plant Code",
					field: "consigner_code",
					width: 120,
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},


				// {
				// 	headerName: "Dist. From Destination (km)",
				// 	field: "distance_from_dealer_location",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		//console.log("params ", params.data);
				// 		if (typeof params.data.distance_from_dealer_location == 'undefined') {

				// 		}
				// 		else {
				// 			return Math.round(params.data.distance_from_dealer_location);
				// 		}

				// 	},
				// 	hide: showonlyactivencr
				// },
				// {
				// 	headerName: "Dealer Code",
				// 	field: "consignee_code",
				// 	width: 150,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "Dealer Name",
				// 	field: "consignee_name",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName: "Dealer City",
				// 	field: "consignee_city",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "Dealer State",
				// 	field: "consignee_state",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },

				// {
				// 	headerName: "GPS Gate In Time",
				// 	field: "inside_fence",
				// 	width: 180,
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false,
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
				// 	},
				// 	resizable: true
				// },
				// {
				// 	headerName: "GPS Gate out Time",
				// 	field: "outside_fence",
				// 	width: 180,
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false,
				// 	//filter: "agDateColumnFilter",
				// 	comparator: dateComparator,

				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.outside_fence);
				// 	},
				// 	resizable: true
				// },
				{
					headerName: "Dist. Traveled last 24Hr (KM)",
					field: "distance_travelled_in_24_hrs_kms",
					//colId : "consignment_code",
					width: 220,
					editable: false,
					filter: "agSetColumnFilter", resizable: true,
					// hide: showdistance,
					valueGetter: function (params) {
						//console.log(params.data.distance_travelled_in_24_hrs_kms);
						if (params.data.distance_travelled_in_24_hrs_kms != "" && params.data.distance_travelled_in_24_hrs_kms != undefined) {
							return params.data.distance_travelled_in_24_hrs_kms;
						}
						else {
							return 0;
						}
					}
					//cellRenderer : "agGroupCellRenderer"
				},
				// {
				// 	headerName: "Truck Reporting Date",
				// 	field: "truck_reporting_date",
				// 	width: 130,
				// 	editable: false,
				// 	// cellEditor:DateEditor,
				// 	valueGetter: (params) => {
				// 		if (params.data.truck_reporting_date != undefined && params.data.truck_reporting_date != null) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.truck_reporting_date)
				// 		}
				// 		else {
				// 			return ""
				// 		}
				// 	},
				// 	resizable: true,
				// 	hide: isHiddenLocalMovement

				// },
				// {
				// 	headerName: "Transshipment",
				// 	field: "is_transshipment",
				// 	width: 110,
				// 	filter: "agSetColumnFilter",
				// 	valueGetter: function (params) {
				// 		if (params.data.is_transshipment == 1) {
				// 			return "Yes";
				// 		}
				// 		else {
				// 			return "No";
				// 		}
				// 	},
				// 	resizable: true,
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority
				// },

				// {
				// 	headerName: "Old Truck No",
				// 	field: "old_truck_no",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority
				// },
				// {
				// 	headerName: "Transshipment Date",
				// 	field: "transshipment_date",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	valueGetter: function (params) {
				// 		return getHyphenDDMMMYYYYHHMM(params.data.transshipment_date);
				// 	},
				// 	// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : false
				// 	hide: hidePriority

				// },

				// {
				// 	headerName: "Reached Destination At",
				// 	field: "first_dealer_reported",
				// 	width: 180,

				// 	hide: hideonlyCol,
				// 	//cellRenderer:'dateFormater',
				// 	valueGetter: function (params) {
				// 		if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	},
				// 	resizable: true,

				// },
				// {
				// 	headerName: "Reached Plant Gate In",
				// 	field: "locked_dealer_reported",
				// 	width: 150,
				// 	//filter: "agDateColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	hide: hideDealerGateIn,
				// 	comparator: dateComparator,
				// 	valueGetter: function (params) {

				// 		if (params.data.locked_dealer_reported != '' && params.data.locked_dealer_reported != undefined
				// 			&& params.data.dest_geofence_id != undefined) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.locked_dealer_reported);
				// 		}
				// 		else {
				// 			return "";
				// 		}
				// 	},
				// },
				{
					headerName: "Last Location",
					field: "address",
					width: 170,
					// hide:showOnlyCol,
					// valueGetter: function (params) {
					// 	//console.log(params.data.transporter);
					// 	try {
					// 		// console.log("params.data.truck.length ", params.data.truck.length)
					// 		if (params.data.truck.length > 0) {
					// 			// console.log("params.data.truck ", params.data.truck)
					// 			if (params.data.truck[0].last_known_address != undefined) {
					// 				if (params.data.truck_no != "" && params.data.truck_no != "") {
					// 					return params.data.truck[0].last_known_address;
					// 				}
					// 				else {
					// 					return "";
					// 				}
					// 			}
					// 			else {
					// 				return "";
					// 			}
					// 		}
					// 		else {
					// 			return "";
					// 		}
					// 	}
					// 	catch (e) {

					// 	}
					// },
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
				// {
				// 	headerName: "Left Destination At",
				// 	field: "left_dealer_marked",
				// 	width: 180,
				// 	//filter: "agDateColumnFilter",
				// 	hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyCol,
				// 	//cellRenderer:'dateFormater',
				// 	valueGetter: function (params) {
				// 		if (params.data.status == 5) {
				// 			return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
				// 		}
				// 		else {
				// 			return "";
				// 		}

				// 	},
				// 	resizable: true,

				// },
				// {
				// 	headerName: "OnTime Delivery",
				// 	field: "ontime_status",
				// 	width: 110,
				// 	hide: hideOnTime,
				// 	valueGetter: function (params) {
				// 		if (params.data.ontime_status == 1) {
				// 			return "On Time";
				// 		}
				// 		else if (params.data.ontime_status == 0) {
				// 			return "Delayed";
				// 		} else {
				// 			return "";
				// 		}
				// 	},
				// 	cellClass: function (params) {
				// 		if (params.data.ontime_status == 1) {
				// 			return "bgColorSuccessMedium";
				// 		}
				// 		else if (params.data.ontime_status == 0) {
				// 			return "bgColorDangerMedium";
				// 		} else {
				// 			return "";
				// 		}
				// 	}


				// },


				// {
				// 	headerName: transitTimeHeading,
				// 	field: "transit_time",
				// 	width: 200,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (department_code == "LOG-PRT") {
				// 			if (params.data.transit_time == 0) {
				// 				return "-";
				// 			}
				// 			else {
				// 				return params.data.transit_time;
				// 			}
				// 		}
				// 		else {
				// 			return params.data.transit_time;
				// 		}

				// 	}
				// },
				// {

				// 	headerName: "No Of Tolls",
				// 	field: "number_of_tolls",
				// 	width: 100,
				// 	filter: "agSetColumnFilter",
				// 	hide: showForDeliveryPrt,
				// 	cellRenderer: '', resizable: true,
				// 	valueGetter: function (params) {
				// 		if (department_code == "LOG-PRT") {
				// 			if (params.data.number_of_tolls !== 0 && params.data.number_of_tolls !== undefined) {
				// 				return params.data.number_of_tolls;
				// 			}
				// 			else if(params.data.status === 6){
				// 				return 'NA'
				// 			}
				// 			else {
				// 				return 0;
				// 			}
				// 		}						
				// 	}
				// },
				{
					headerName: "Expected Distance (KM)",
					field: "distance_in_km",
					width: 200,
					filter: "agSetColumnFilter",
					cellRenderer: '', 
					resizable: true,
					valueGetter: (params)=>{
						if(params.data.distance_in_km>=0){
							return params.data.distance_in_km
						}
						return 0
					}
				},
				
				// {
				// 	headerName: "Sim Tracking State",
				// 	field: "sim_tracking_state",
				// 	width: 120,
				// 	// pinned: 'left',
				// 	// hide : hideStatus,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	valueGetter: (params) => {
				// 		//console.log("GPS ", params.data.gps_data_available);
				// 		if(params.data.sim_tracking_state != undefined && params.data.sim_tracking_state != "" && params.data.sim_tracking_state != null){
				// 			if (params.data.sim_tracking_state == 4 
				// 				|| params.data.sim_tracking_state == 17
				// 				|| params.data.sim_tracking_state == 20
				// 				||params.data.sim_tracking_state == 23 ) {
				// 				return "DEACTIVATED"
				// 			}
				// 			else if (params.data.sim_tracking_state == 1) {
				// 				return "YET TO REGISTER"
				// 			}
				// 			else if (params.data.sim_tracking_state == 6) {
				// 				return "PENDING FOR CONSENT APPROVAL"
				// 			}
				// 			else if (params.data.sim_tracking_state == 8 || params.data.sim_tracking_state == 10) {
				// 				return "CONSENT DECLINED"
				// 			}
				// 			else if (params.data.sim_tracking_state == 3 || params.data.sim_tracking_state == 7 || params.data.sim_tracking_state == 9 || params.data.sim_tracking_state == 16 || params.data.sim_tracking_state == 19) {
				// 				return "ENABLED"
				// 			}
				// 			else {
				// 				return "YET TO TRACK"
				// 			}
				// 		}else{
				// 			return ""
				// 		}
				// 	}
				// },
				// {
				// 	headerName: "Driver Name",
				// 	field: "driver_name",
				// 	width: 150,
				// 	// hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				{
					headerName: "Driver Number",
					field: "driver_mobile_no",
					width: 150,
					// hide: hideonlyTNP,
					filter: "agSetColumnFilter",
					cellRenderer: '', resizable: true
				},
				// {
				// 	headerName: "Sim Operator",
				// 	field: "sim_operator_name",
				// 	width: 150,
				// 	hide: hideonlyTNP,
				// 	filter: "agSetColumnFilter",
				// 	cellRenderer: '', resizable: true
				// },
				// {
				// 	headerName:"Resend Consent",
				// 	field : "recent_consent",
				// 	width : 120,
				// 	cellRendererSelector : function(params){
				// 					if (params.data.transporter_code == '141750'){
				// 						return ""
				// 					}else{
				// 						var rendComponent = {
				// 							component: 'RecentConsent'
				// 						};
				// 						return rendComponent
				// 					}
									
				// 	},
				// 	hide:isArcLogin
				// },
				// {
				// 	headerName:"Change Driver Details",
				// 	field : "change_driver_details",
				// 	width : 160,
				// 	cellRendererSelector: function(params){
				// 		if (params.data.transporter_code== '141750'){
				// 			return ""
				// 		}else{
				// 			var rendComponent = {
				// 				component: 'ChangeDriverDetails'
				// 			};
				// 			return rendComponent
				// 		}
				// 	},
				// 	hide:isHideChangeDriverButton
				// },
				// {
				// 	headerName: "Remarks",
				// 	field: "transit_time_remarks",
				// 	width: 110,
				// 	editable:true,
				// 	// hide: (localStorage.getItem("transportercode").includes("T305")|| localStorage.getItem("transportercode").includes("T329"))?false:true,	
				// 	// valueSetter:(params)=>{
				// 	// // console.log(params)
				// 	// 	if(params.oldValue != params.newValue)
				// 	// 	{
				// 	// 		var data = {
				// 	// 			truck_no:params.data.truck_no,
				// 	// 			transit_time_remarks:params.newValue,
				// 	// 			email:localStorage.getItem("email")
				// 	// 		}
				// 	// 		params.data.transit_time_remarks = params.newValue;
				// 	// 		redirectURL.post("/consignments/updatetransittimeremarks", data,{
				// 	// 		headers:{
				// 	// 			'Content-Type': 'application/json'
				// 	// 			}
				// 	// 			}).then((response)=>{
				// 	// 		})
				// 	// 	}
				// 	// }
				// },
				

				

				// {
				// 	headerName: "Force Close",
				// 	field: "",
				// 	width: 80,
				// 	// hide: showOnlyCol,
				// 	// cellRendererSelector: function (params) {
				// 	// 	var rendComponent = {
				// 	// 		component: 'consignmentforceclose'
				// 	// 	};
				// 	// 	return rendComponent;
				// 	// },
				// 	filter: false, resizable: true,


				// },
                // {
				// 	headerName: "Add Dealer",
				// 	field: "add_dealer",
				// 	width: 80,
				// 	// hide: showOnlyCol,
				// 	cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: AddDealerConsignments,
                //                     params: {
                //                         onClickActive: onClickActive
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
				// },

				
				// {
				// 	headerName: "Force Closed Reason",
				// 	field: "force_closure_reason",
				// 	width: 200,
				// 	// hide: showOnlyColDeliver,
				// 	cellClass: ['wraptext'],
				// 	filter: false, resizable: true,

				// {
				// 	headerName: "Route",
				// 	field: "parent_route",
				// 	width: 120,
				// 	filter: "agSetColumnFilter",
				// 	resizable: true,
				// 	pinned:"left",
				// },



			];

    useEffect(() => {
        if (window.location.pathname == "/activecourierconsignments") {
            setRowData(activeTrips.all)
            setTabName(tabOptions[0])
        }
        else if (window.location.pathname == "/deliveredcourierconsignments") {
            setRowData(completedTrips.all)
            setTabName(tabOptions[1])
        }
        else if (window.location.pathname == "/courierconsignments") {
            setRowData(allTrips.all)
            setTabName(tabOptions[2])
        }
    }, [window.location.pathname])

    const onClickActive = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        // setshowAddForm("slide30");
        setshowAddForm("slider-translate-30p");
        setOverlay("show-m");
      };

    const onClickHideAll = () => {
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
    }
    const saveConsignmentData = async (event) => {
        event.preventDefault();
        let specialCharcters = 0;
        const { truck_no, plant_code, grno_consignment_code, invoice_no, driver_name, driver_mobile_num, mobile_operator, transit_days, consignee_code, consignee_name } = formData;
        const invoice_date = document.getElementById('invoice_date').value;
        const created_by = localStorage.getItem('email');
        // const encode = cipher('V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x');
        let transporter_code = '';

        if (localStorage.getItem('user_type') === 'TRANSPORTER') {
            const tpt_code = JSON.parse(localStorage.getItem('transportercode'));
            transporter_code = tpt_code[0];
        } else {
            transporter_code = formData.transporter_code;
        }

        const gate_out_time = document.getElementById('gate_out_time').value;

        if (truck_no && truck_no.match(/[^a-zA-Z0-9]/g)) {
            specialCharcters = 1;
        }

        if (specialCharcters === 0) {
            let fieldsChk = 0;
            if (truck_no && plant_code && grno_consignment_code && invoice_no && invoice_date && gate_out_time && consignee_code) {
                fieldsChk = 1;
            }

            if (fieldsChk === 1) {
                const params = {
                    truck_no,
                    plant_code,
                    plant_name: formData.plant_name,
                    consignment_code: grno_consignment_code,
                    invoice_no,
                    invoice_date,
                    gate_out_time,
                    consignee_code,
                    consignee_name,
                    driver_name,
                    driver_mobile_number: driver_mobile_num,
                    sim_tracking_service_provider: parseInt(mobile_operator),
                    transit_days,
                    transporter_code,
                    created_by,
                };

                try {
                    const response = await redirectURL.post('/dashboard/saveConsignmentData', params);
                    if (response.data.status === 'success') {
                        document.getElementById('invoice_date').value = '';
                        document.getElementById('gate_out_time').value = '';
                        setFormData({
                            ...formData,
                            show: true,
                            basicType: 'success',
                            basicTitle: 'Successfully created consignment',
                            sliderCreateConsignmentTranslate: '',
                            truck_no: '',
                            plant_code: '',
                            plant_name: '',
                            grno_consignment_code: '',
                            invoice_no: '',
                            consignee_code: '',
                            consignee_name: '',
                            driver_name: '',
                            driver_mobile_num: '',
                            mobile_operator: '',
                            transporter_code: '',
                            loadshow: 'show-n',
                            overly: 'show-n',
                            transit_days: '',
                        });
                        // Call componentDidMount equivalent
                    } else {
                        setFormData({
                            ...formData,
                            show: true,
                            basicType: 'danger',
                            basicTitle: response.data.message === 'Consignment Code Already Exists' ? 'Consignment Code Already Exists' : 'Failed to create consignment',
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
                setFormData({
                    ...formData,
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'All fields are mandatory',
                });
            }
        } else {
            setFormData({
                ...formData,
                show: true,
                basicType: 'danger',
                basicTitle: 'Special characters are not allowed',
            });
        }
    };

    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setReasonForceClose('')
        setRownode([])
    }

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
        setReasonForceClose('')
    }

    const saveGrid = async (e) => {
        let coloumnState = columnApiConsignments.current.getColumnState()
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
            reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const formForceCloseHandler = (e) => {
        e.preventDefault()
        var consignemnt = rownode;
        var consignment_code = consignemnt.consignment_code;
        var truck_no = consignemnt.truck_no;
        var dept_code = "SNDG";
        var email = user?.email;
        var reqdata = {
            dept_code: dept_code,
            consignment_code: [consignment_code],
            truck_no: truck_no,
            email: email,
            reasonforceclose: reasonForceClose,
        }
        redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
            .then((response) => {
                if (response.data.status == 'Success') {
                    setShow(true)
                    setTitle("Successfully Force Closed the consignment")
                    setType("success")
                    closeForceCloseModal()
                    reloadPage.current = true
                }
                else {
                    setShow(true)
                    setTitle("Failed to Force Close")
                    setType("danger")
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };
    // async onClickShowShipmentLegs(params) {
	// 	console.log("params", params)
	// 	if (params != 0) {
	// 		var transitedelaydata = [];

	// 		await this.setState({

	// 			detailCellRendererParams: {
	// 				suppressRefresh: true,
	// 				detailGridOptions: {
	// 					headerHeight: 50,
	// 					columnDefs: [
	// 						{
	// 							headerName: "",
	// 							field: "legs_map",
	// 							colId: "legs_map",
	// 							width: 40,
	// 							pinned: 'left',
	// 							cellRenderer:function(params){
	// 								var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
	// 								return htmloption;
	// 							} ,
	// 							filter: false, resizable: true
			
	// 						},
	// 						{
	// 							headerName: "Invoice No",
	// 							field: "invoice_no",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Consignment",
	// 							field: "consignment_code",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Original ETA",
	// 							field: "expected_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}
	// 							},

	// 						},
	// 						{
	// 							headerName: "Revised ETA",
	// 							field: "revised_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}

	// 							}
	// 						},
							
	// 						{
	// 							headerName: "Status",
	// 							field: "status",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// },
								

	// 							valueGetter: function (params) {
	// 								//console.log("GPS ", params.data.gps_data_available);
	// 								if (params.data.status == 1) {
	// 									return "Inside Plant"
	// 								}
	// 								else if (params.data.status == 2) {
	// 									return "In Transit"
	// 								}
	// 								else if (params.data.status == 3) {
	// 									return "Near Destination"
	// 								}
	// 								else if (params.data.status == 4) {
	// 									return "Reached Destination"
	// 								}

	// 								else if (params.data.status == 5) {
	// 									return "Left Destination"
	// 								}
	// 								else if (params.data.status == 6) {
	// 									return "Force Closed"
	// 								}
	// 								else if (params.data.status == 8) {
	// 									return "Crossdock"
	// 								}else if(params.data.status == 9){
	// 									return "Trip Completed"
	// 								}
	// 								else {
	// 									return ""
	// 								}

	// 							}
	// 						},
	// 						{
	// 							headerName: "Zone",
	// 							field: "zone",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
							
	// 						{
	// 							headerName: "Dealer Code",
	// 							field: "consignee_code",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Dealer City",
	// 							field: "consignee_city",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},

	// 						{
	// 							headerName: "Dealer Name",
	// 							field: "consignee_name",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Trip Distance (KM)",
	// 							field: "distance_in_km",
	// 							width: 120,
	// 							resizable: true,
	// 							valueGetter: params =>{
	// 								if(params.data.distance_in_km>0){
	// 									return params.data.distance_in_km
	// 								}else{
	// 									return 0
	// 								}
	// 							}
	// 							,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Distance from Dealer (KM)",
	// 							field: "distance_from_dealer_location",
	// 							width: 160,
	// 							valueGetter: function (params) {
	// 								if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
	// 									return params.data.distance_from_dealer_location;
	// 								}
	// 								else {
	// 									return "";
	// 								}
	// 							},
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Reached Destination At",
	// 							field: "first_dealer_reported",
	// 							width: 180,


	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Left Destination At",
	// 							field: "left_dealer_marked",
	// 							width: 180,
	// 							//filter: "agDateColumnFilter",
	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 5) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Transit Time (Days)",
	// 							field: "transit_time",
	// 							width: 200,
	// 							filter: "agSetColumnFilter",
	// 							cellRenderer: '', resizable: true
	// 						},
							
	// 					],
	// 					overlayNoRowsTemplate: 'No rows to show',
	// 					onCellClicked:(leg_params) =>{
	// 						if(leg_params.colDef.field =="legs_map"){
	// 							if(leg_params.data.status==8){
	// 								this.setState({
	// 									show: true,
	// 									basicTitle: 'No Route data available',
	// 									basicType: "danger",
	// 									loadshow: 'show-n'
	// 								});
	// 							}else{
								
	// 								var leg_params = leg_params.data
	// 								this.setState({
	// 									loadshow: 'show-m',
	// 									maptruckno: leg_params.truck_no
	// 								});
							
	// 								// If gateouttime is current time - It shows "No Route data available"
	// 								if (leg_params.invoice_time) {
	// 									var gateouttime = moment.parseZone(leg_params.invoice_time).format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								else {
	// 									if (leg_params.gate_in_time) {
	// 										var gateouttime = moment.parseZone(leg_params.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
	// 									}
	// 									else {
	// 										if (leg_params.gate_out_time) {
	// 											var gateouttime = moment.parseZone(leg_params.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
	// 										}
	// 									}
	// 								}
							
	// 								var edate = '';
	// 								var end_date;
	// 								if (leg_params.status <= 2) {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}
	// 								else if (leg_params.status == 3 || leg_params.status == 4) {
	// 									if (leg_params.recent_dealer_reported) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 										end_date = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 									}
	// 								}
	// 								else if (leg_params.status == 5) {
	// 									if (leg_params.left_dealer_marked) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 										end_date =  getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 									}
	// 								}
	// 								else if (leg_params.status == 6) {
	// 									if (leg_params.force_closure_time) {
	// 										let splitT = leg_params.force_closure_time.split('T')
	// 										let yMD = splitT[0]
	// 										let hMS = splitT[1]
	// 										let hms1 = hMS.split('.')
	// 										let finalHms = hms1[0]
	// 										let final_end_date = yMD + ' ' + finalHms
	// 										end_date = final_end_date;
	// 										edate = final_end_date
	// 									}
	// 								}
	// 								else {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}							
	// 								if ((leg_params.transit_time) > 0) {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + ((leg_params.transit_time + 1) * 24 * 60 * 60 * 1000));
	// 								}
	// 								else {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
	// 								}
							
	// 								var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();
							
	// 								if (!end_date) {
	// 									// When end date is unavailable then current date is considered as end date.
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								var reqData = {
	// 									truck_no: leg_params.truck_no,
	// 									consignment_code: leg_params.invoice_no,
	// 									consignee_code: leg_params.consignee_code,
	// 									gate_out_time: gateouttime,
	// 									seconddate: end_date,
	// 									screen: "consignment"
	// 								}
	// 								if (["2", "3", "4"].includes(leg_params.status)) reqData.mapMode = 2
							
	// 								redirectURL.post('/consignments/maproutes', reqData, {
	// 									headers: {
	// 										'content-type': 'application/json'
	// 									}
	// 								})
	// 									.then((response) => {
	// 										var records = response.data;
	// 										console.log(records,"record3535")
	// 										this.setState({
	// 											loadshow: 'show-m'
	// 										});
	// 										try {
	// 											if (records.coords.length == 0 || records.status == "failure") {
	// 												this.setState({
	// 													show: true,
	// 													basicTitle: 'No Route data available',
	// 													basicType: "danger",
	// 													loadshow: 'show-n'
	// 												});
	// 											}
	// 											else {
	// 												if (records != '') {
	// 													var sdate = leg_params.gate_out_time;
	// 													if (leg_params.invoice_time) {
	// 														var sdate = leg_params.invoice_time;
	// 													}
	// 													else {
	// 														if (leg_params.gate_in_time) {
	// 															var sdate = leg_params.gate_in_time;
	// 														}
	// 														else {
	// 															if (leg_params.gate_out_time) {
	// 																var sdate = leg_params.gate_out_time;
	// 															}
	// 														}
	// 													}
							
							
	// 													var edate = '';
	// 													var end_date = ""
	// 													console.log(leg_params.recent_dealer_reported , "recent_dealer_reported")
	// 													if (leg_params.status < 4) {
	// 														end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 														edate = getHyphenDDMMYYYYHHMMSS(end_date);
							
	// 													}
	// 													else if (leg_params.status == 4 ) {
	// 														console.log("end_time", leg_params)
	// 														edate = getHyphenDDMMYYYYHHMMSS(leg_params.end_time);
	// 														end_date = leg_params.recent_dealer_reported
	// 													}
	// 													else if (leg_params.status == 5) {
	// 														if (leg_params.left_dealer_marked) {
	// 															edate = getHyphenDDMMYYYYHHMMSS(leg_params.left_dealer_marked);
	// 															end_date = leg_params.left_dealer_marked
							
	// 														}
	// 														else {
	// 															end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 															edate = getHyphenDDMMYYYYHHMMSS(end_date);
	// 														}
	// 													}
	// 													if (leg_params.deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
	// 														var params = {
	// 															"base_route_id": leg_params.base_route_id
	// 														}
	// 														redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
	// 															params).then((resp) => {
	// 																this.setState({
	// 																	sliderRouteTranslate: "slider-translate-60p",
	// 																	showDiv: 'show-m',
	// 																	mapinfo: records,
	// 																	dealer: leg_params.consignee_code,
	// 																	consignment_code: "Truck No : " + leg_params.truck_no,
	// 																	maptruckno: leg_params.truck_no,
	// 																	routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 																	loadshow: 'show-n',
	// 																	sidebarSubHeader: "Consignment Information",
	// 																	overly: 'show-m',
	// 																	rownode: leg_params,
	// 																	leg_no: 0,
	// 																	tolls: records.tolls,
	// 																	baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
	// 																	devation_flag: true
	// 																});
	// 																this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 																this.renderMap();
	// 															})
	// 													}
	// 													else {
	// 														this.setState({
	// 															sliderRouteTranslate: "slider-translate-60p",
	// 															showDiv: 'show-m',
	// 															mapinfo: records,
	// 															dealer: leg_params.consignee_code,
	// 															consignment_code: "Invoice No : " + leg_params.invoice_no,
	// 															maptruckno: leg_params.truck_no,
	// 															routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 															loadshow: 'show-n',
	// 															sidebarSubHeader: "Consignment Information",
	// 															overly: 'show-m',
	// 															rownode: leg_params,
	// 															leg_no: 0,
	// 															tolls: records.tolls
	// 														});
	// 														this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 														this.renderMap();
	// 													}
	// 												}
	// 											}
	// 										}
	// 										catch (e) {
	// 											this.setState({
	// 												show: true,
	// 												basicTitle: 'No Route data available',
	// 												basicType: "danger",
	// 												loadshow: 'show-n'
	// 											});
	// 										}
							
	// 									})
	// 									.catch(function (error) {
	// 										console.log(error);
	// 									});
	// 							}
	// 						}
	// 					}
	// 				},
	// 				getDetailRowData: function (params) {
	// 					console.log("Step 4 ", transitedelaydata)
	// 					console.log("Step 4 ", params)
	// 					redirectURL.post('/consignments/getShipmentDetails', {
	// 						shipment_id: params.data.shipment_id
	// 					})
	// 						.then(async (response) => {
	// 							console.log(response.data , "srinu")
	// 							params.successCallback(response.data || []);
	// 							//console.log("Step 2 ",response.data)

	// 						});

	// 				}
	// 			}
	// 		});

	// 		//if( params.column.colId == 'transit_delay' || params.column.colId == 'transit_delay_1' ||   params.column.colId == 'no_gps_data' || params.column.colId == 'no_gps_data_1')
	// 		if (params.column.colDef.field == 'shipmentlegs') {
	// 			params.node.setExpanded(!params.node.expanded);
	// 			//console.log("expanded ",params.node.expanded)
	// 			if (params.node.expanded == false) {
	// 				transitedelaydata = []
	// 			}
	// 		}
	// 		else {

	// 			params.node.setExpanded(false);
	// 		}
	// 		//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

	// 	}

	// }
    
 const   onShowCourierTrack = async (params) => {
		// if (googleAnalytics.page.enableGA) {
		// 	let pageTitle = this.state.pageTitle;
		// 	// let eventOptions = {
		// 	// 	"category": pageTitle,
		// 	// 	"action": this.state.eventGridAction,
		// 	// 	"label": googleAnalytics.page.action.trackCourier,
		// 	// }
		// 	// googleAnalytics.logEvent(eventOptions);
		// }
        redirectURL.post('/consignments/trackcourier',{consignment_code:params.data.consignment_code} )
        .then(resp => {
            console.log(resp, "respppppp")
            if (resp.data.consignments?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: [
							
							{ 
                                headerName: "Transit Date",
                                field: "intransit_date", 
                                valueGetter:function(params){
									console.log("IN onShowCourierTrack, params.data = ", params.data);
                                  // var intransitdate=getDDMMYYYY(params.data.intransit_date)+" "+params.data.intransit_time
                                   var intransitdate= params.data.intransit_date +" "+ params.data.intransit_time
								   return intransitdate
								},
								filter:true,
								resizable:true
                            },
							{ 
                                headerName: "Location",
                                field: "intransit_location", 
                                filter:true,
								resizable:true 
                            },
							{ 
                                headerName: "Status",
                                field: "intransit_status", 
                                filter:true ,
								resizable:true
                            }
						],	
                        defaultColDef: {
                            flex: 3,
                        },
                    },
                    getDetailRowData: (params) => {
                        // params.successCallback(resp.data);
                        params.successCallback(resp.data.consignments);
                    },
                })
            // }
        // })
        // .catch(err => {
        //     console.log(err);
        // })
            }})
        // if(params != 0)
		// {
			
		// 	await this.setState({
					
		// 		setdetailCellRendererParams:{
		// 			detailGridOptions: {
												
		// 			},
		// 			getDetailRowData: function(params) {
		// 				//console.log("Step 4 ",overspeedData)
		// 				redirectURL.post('/consignments/trackcourier', {
		// 					consignment_code:params.data.consignment_code
		// 				})
		// 				.then(async (response) =>{
        //                     //console.log("Step 1 ",response.data)
        //                     //console.log("test ", response);
        //                     var trackData=response.data;
        //                     //console.log("trackData ", trackData)
        //                     if(trackData.status == 'failure')
        //                     {
        //                         params.successCallback([]);
        //                     }
        //                     else{
        //                         params.successCallback(trackData);
        //                     }
							
		// 					//console.log("Step 2 ",response.data)
							
		// 				});
						 
		// 			},
		// 			masterDetail: true
		// 		}
		// 	});
			
		// 	//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);
			
		// }
		// //console.log("params.column.colId ", params.column)
		// if(params.column.colDef.field == '_id')
		// {
		// 	params.node.setExpanded(!params.node.expanded);
		// }
		// else{

		// 	params.node.setExpanded(false);
		// }
    }
    const onClickShowShipmentLegs = async (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/getShipmentDetails', query)
            .then(resp => {
                console.log(resp, "respppppp")
                if (resp.data.consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: [
                                // {
                                //     headerName: "",
                                //     field: "legs_map",
                                //     colId: "legs_map",
                                //     width: 40,
                                //     pinned: 'left',
                                //     cellRenderer:function(params){
                                //         var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                                //         return htmloption;
                                //     } ,
                                //     filter: false, resizable: true
                
                                // },
                                {
                                    headerName: "Invoice No",
                                    field: "invoice_no",
                                    width: 140,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                // {
                                //     headerName: "Consignment",
                                //     field: "consignment_code",
                                //     width: 140,
                                //     // cellClass: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                {
                                    headerName: "Original ETA",
                                    field: "expected_trip_end",
                                    width: 10,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                                    },
                                    cellClass: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
                                    },
    
                                },
                                {
                                    headerName: "Revised ETA",
                                    field: "revised_trip_end",
                                    width: 180,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                                    },
                                    cellClass: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
    
                                    }
                                },
                                
                                {
                                    headerName: "Status",
                                    field: "status",
                                    width: 140,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // },
                                    
    
                                    valueGetter: function (params) {
                                        //console.log("GPS ", params.data.gps_data_available);
                                        if (params.data.status == 1) {
                                            return "Inside Plant"
                                        }
                                        else if (params.data.status == 2) {
                                            return "In Transit"
                                        }
                                        else if (params.data.status == 3) {
                                            return "Near Destination"
                                        }
                                        else if (params.data.status == 4) {
                                            return "Reached Destination"
                                        }
    
                                        else if (params.data.status == 5) {
                                            return "Left Destination"
                                        }
                                        else if (params.data.status == 6) {
                                            return "Force Closed"
                                        }
                                        else if (params.data.status == 8) {
                                            return "Crossdock"
                                        }else if(params.data.status == 9){
                                            return "Trip Completed"
                                        }
                                        else {
                                            return ""
                                        }
    
                                    }
                                },
                                // {
                                //     headerName: "Zone",
                                //     field: "zone",
                                //     width: 100,
                                //     // cellClass: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                
                                {
                                    headerName: "Dealer Code",
                                    field: "consignee_code",
                                    width: 200,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Dealer City",
                                    field: "consignee_city",
                                    width: 120,
                                    resizable: true,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
    
                                {
                                    headerName: "Dealer Name",
                                    field: "consignee_name",
                                    width: 150,
                                    resizable: true,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Trip Distance (KM)",
                                    field: "distance_in_km",
                                    width: 150,
                                    resizable: true,
                                    valueGetter: params =>{
                                        if(params.data.distance_in_km>0){
                                            return params.data.distance_in_km
                                        }else{
                                            return 0
                                        }
                                    }
                                    ,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Distance from Dealer (KM)",
                                    field: "distance_from_dealer_location",
                                    width: 200,
                                    valueGetter: function (params) {
                                        if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                                            return params.data.distance_from_dealer_location;
                                        }
                                        else {
                                            return "";
                                        }
                                    },
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Reached Destination At",
                                    field: "first_dealer_reported",
                                    width: 180,
    
    
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Left Destination At",
                                    field: "left_dealer_marked",
                                    width: 180,
                                    //filter: "agDateColumnFilter",
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 5) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Transit Time (Days)",
                                    field: "transit_time",
                                    width: 200,
                                    filter: "agSetColumnFilter",
                                    cellRenderer: '', resizable: true
                                },
                                
                            ],
                            defaultColDef: {
                                flex: 3,
                            },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
                }})}
// })};
    // const handleCellClick = (leg_params) => {
    //     setLoadshow('show-m');
    //     setMaptruckno(leg_params.data.truck_no);

    //     let gateouttime = getGateOutTime(leg_params.data);

    //     let end_date = getEndDate(leg_params.data);
    //     let edate = getHyphenYYYYMMDDHHMMSS(end_date);

    //     let sdate = getSecondDate(leg_params.data);

    //     if (!end_date) {
    //         end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    //         edate = getHyphenYYYYMMDDHHMMSS(end_date);
    //     }

    //     const reqData = {
    //         truck_no: leg_params.data.truck_no,
    //         consignment_code: leg_params.data.invoice_no,
    //         consignee_code: leg_params.data.consignee_code,
    //         gate_out_time: gateouttime,
    //         seconddate: end_date,
    //         screen: "consignment"
    //     };

    //     if (["2", "3", "4"].includes(leg_params.data.status)) reqData.mapMode = 2;

    //     redirectURL.post('/consignments/maproutes', reqData, {
    //         headers: {
    //             'content-type': 'application/json'
    //         }
    //     })
    //         .then(response => handleRouteResponse(response, leg_params.data))
    //         .catch(error => console.error(error));
    // };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };


    const onShowTransitRouteMap = (rownode) => {
        var d = new Date(rownode.leg_start);
        var r = new Date(rownode.leg_end_eta);
        var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        consignment_code: rownode.truck_no,
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": response.data['route_details']['start_time'],
                            "endTime": response.data['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: response.data.tolls
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowRouteMap = (rownode) => {
        var d = new Date(rownode.first_instance);
        var r = new Date(rownode.recent_instance);
        var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    consignment_code: "Vehicle No. : " + rownode.truck_no,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-84p"
        })
    }
    const closeBulkUploadModal = () => {
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setModalLoadData([])
    }
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setMapDetails()
    }
    const openMapModal = () => {

    }

    const CounterClick = (ecounter) => {
        if (tabName.value == "active") {
            switch (ecounter) {
                case "consignments":
                    setRowData(activeTrips.all)
                    break;
                case "transit_delays":
                    setRowData(activeTrips.transit_delay)
                    break;
                // case "overspeeding":
                //     setRowData(activeTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(activeTrips.night_driving)
                //     break;
                case "stoppages":
                    setRowData(activeTrips.stoppages)
                    break;
                case "accidents":
                    setRowData(activeTrips.accidents)
                    break;
                case "trip_deviations":
                    setRowData(activeTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(activeTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(activeTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(activeTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setRowData(activeTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "completed") {
            switch (ecounter) {
                case "consignments":
                    setRowData(completedTrips.all)
                    break;
                case "transit_delays":
                    setRowData(completedTrips.transit_delay)
                    break;
                // case "overspeeding":
                //     setRowData(completedTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(completedTrips.night_driving)
                //     break;
                case "stoppages":
                    setRowData(completedTrips.stoppages)
                    break;
                case "accidents":
                    setRowData(completedTrips.accidents)
                    break;
                case "trip_deviations":
                    setRowData(completedTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(completedTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(completedTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(completedTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setRowData(completedTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "all") {
            switch (ecounter) {
                case "consignments":
                    setRowData(allTrips.all)
                    break;
                case "transit_delays":
                    setRowData(allTrips.transit_delay)
                    break;
                // case "overspeeding":
                //     setRowData(allTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(allTrips.night_driving)
                //     break;
                case "stoppages":
                    setRowData(allTrips.stoppages)
                    break;
                case "accidents":
                    setRowData(allTrips.accidents)
                    break;
                case "trip_deviations":
                    setRowData(allTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setRowData(allTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setRowData(allTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setRowData(allTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setRowData(allTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
    }

    useEffect(() => {
        let key = ''
        redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = async () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post('consignments/getConsigner')
            .then((response) => {
                setConsignersList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post("/consignments/getConsignmentsNewFilterKeys", { dept_code: "SNDG" })
            .then((resp) => {
                var cities = resp.data.cities;
                var filterCities = [];
                if (cities != undefined) {
                    if (cities.length > 0) {
                        cities.map(function (c) {
                            filterCities.push({
                                label: c,
                                value: c,
                            });
                        });
                    }
                }
                var states = resp.data.states;
                var filterStates = [];
                if (states != undefined) {
                    if (states.length > 0) {
                        states.map(function (s) {
                            filterStates.push({
                                label: s,
                                value: s,
                            });
                        });
                    }
                }
                var clusters = resp.data.clusters;
                var filterClusters = [];
                if (clusters != undefined) {
                    if (clusters.length > 0) {
                        clusters.map(function (cl) {
                            filterClusters.push({
                                label: cl,
                                value: cl,
                            });
                        });
                    }
                }
                var transporters = resp.data.transporters;
                var filterTransporters = [];
                if (transporters != undefined) {
                    if (transporters.length > 0) {
                        transporters.map(function (t) {
                            filterTransporters.push({
                                label: t,
                                value: t,
                            });
                        });
                    }
                }
                setFilterCities(filterCities)
                setFilterStates(filterStates)
                setFilterTransporters(filterTransporters)
            })
        loadConsignmentsData()
        fetchGridLayout(user.email, "consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            .catch(err => console.log(err))
    }, [])

    useEffect(() => {
        if (gridColumnState.length > 0 && columnApiConsignments.current) {
            columnApiConsignments.current.applyColumnState({
                state: gridColumnState,
                applyOrder: true,
            })
        }
    }, [gridColumnState, columnApiConsignments])


    const changeFileHandler = (e) => {
        setLoader(true)
        const formData = new FormData()
        formData.append("fileUpload", e.target.files[0])
        redirectURL.post("/readExcel", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
            .then((response) => {
                if (response.data.status == "success") {
                    if (response.data.data.length > 0) {
                        setModalLoadData(response.data.data)
                        setPlantData(response.data.plantData)
                        setTransporters(response.data.transporters)
                        setDealers(response.data.dealers)
                        setPreviousData(response.data.previousData)
                    }
                    else {
                        setModalLoadData([])
                    }
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")
                }
            })
            .catch(error => {
                console.log(error);
            })
        setLoader(false)
    }

    const onClickShowRoute = (rownode) => {
        setLoader(true)
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        var gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            }
            else if (e.left_dealer_marked) {
                end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = getHyphenDDMMMYYYYHHMM(e.force_closure_time);
            }
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if ((e.transit_time) > 0) {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + ((e.transit_time + 1) * 24 * 60 * 60 * 1000));
        }
        else {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
        }

        var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            //console.log("Defining end_date ", end_date);
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment"
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle("No GPS data available")
                        setType("danger")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (e.deviation_flag == 1) {
                                let consignee_city;
                                consignee_city = e.consignee_city
                                var params = {
                                    "base_route_id": e.base_route_id,
                                    "consigner_code": e.consigner_code,
                                    "consignee_city": consignee_city
                                }
                                redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                                    params).then((resp) => {
                                        var baseRouteCoords = eval(resp.data.route_coords);
                                        setOpenMap({
                                            overly: "show-m",
                                            sliderRouteTranslate: "slider-translate-60p",
                                            mapinfo: records,
                                            dealer: e.consignee_code,
                                            consignment_code: "Consignment : " + e.consignment_code,
                                            maptruckno: e.truck_no,
                                            routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                            loadshow: 'show-n',
                                            sidebarSubHeader: "Consignment Information",
                                            rownode: e,
                                            leg_no: 0,
                                            tolls: records.tolls,
                                            baseRouteCoords: baseRouteCoords
                                        })
                                    })
                                setLoadShow("show-n")
                            }
                            else {
                                var params =
                                {
                                    consignee_code: e.consignee_code,
                                    dept_code: e.dept_code
                                }
                                redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                    var records1 = response.data.records;
                                    let parkingGeodata = []
                                    if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                    var geofence_coords = []
                                    if (records1.length) {
                                        geofence_coords = records1[0].geofence_coordinates;
                                    }
                                    setOpenMap({
                                        sliderRouteTranslate: "slider-translate-60p",
                                        showDiv: 'show-m',
                                        mapinfo: records,
                                        dealer: e.consignee_code,
                                        consignment_code: "Consignment : " + e.consignment_code,
                                        maptruckno: e.truck_no,
                                        geofence_coordinates: geofence_coords,
                                        parking_coordinates: parkingGeodata,
                                        routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                        loadshow: 'show-n',
                                        sidebarSubHeader: "Consignment Information",
                                        overly: 'show-m',
                                        rownode: e,
                                        leg_no: 0,
                                        tolls: records.tolls
                                    })
                                    setLoadShow("show-n")
                                })
                            }
                        }
                    }
                }
                catch (e) {
                    // setShow(true)
                    // setTitle("No GPS data available")
                    // setType("danger")
                }

            })
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
    }

    const onShowTransitData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code,
            consignee_code: params.data.consignee_code
        }
        redirectURL.post('/consignments/transitdelay', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: transitdelaycols,
                            defaultColDef: {
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowStoppagesData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/enroutes', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: stoppagescols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowOverspeedingData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/overspeed', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: overspeedcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowNightDrivingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nightdrivingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nightdriving = []
                redirectURL.post('/consignments/nightdriving', {
                    consignment_code: params.data.consignment_code,
                    gate_out_time: params.data.gate_out_time,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        //console.log("Step 1 ",response.data)
                        nightdriving = response.data;
                        params.successCallback(nightdriving);
                        //console.log("Step 2 ",response.data)

                    });
            },
        })
    }

    const onShowLoadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: [

                    {
                        headerName: "Gate In Time",
                        field: "gate_in_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_in_time) {
                                return params.data.gate_in_time;
                            }
                            else {
                                return "NA"
                            }

                        }
                    },
                    {
                        headerName: "Gate Out Time",
                        field: "gate_out_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_out_time) {
                                return params.data.gate_out_time;
                            }
                            else {
                                return "NA"
                            }
                        }
                    },
                    {
                        headerName: "Loading Time",
                        field: "loading_time",
                        width: 180,
                    }
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.gate_in_time != undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.gate_in_time);
                    var gdate1 = new Date(params.data.gate_in_time);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.gate_in_time)).format("x")
                }
                else {

                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
                    var gdate1 = new Date(params.data.inside_fence);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.inside_fence)).format("x")

                }
                if (params.data.gate_out_time != undefined) {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var gdate2 = new Date(params.data.gate_out_time);
                    var toField = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var secondsgate2 = moment.parseZone(new Date(params.data.gate_out_time)).format("x")
                }
                else {
                    var c = new Date();
                    var todaydate = moment(new Date(c)).format("x");
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var gdate2 = new Date(todaydate);
                    var toField = getHyphenDDMMMYYYYHHMM(new Date());
                    var secondsgate2 = todaydate

                }

                var total = secondsgate2 - secondsgate1;
                var diffMs = total;
                var diffDays = Math.ceil(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                let loadingTimeDifference = null;
                var dataarr = []
                dataarr.push({
                    "gate_in_time": fromDate,
                    "gate_out_time": toField,
                    "loading_time": secondsToString(diffMs / 1000)
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowUnloadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: unloadingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.locked_dealer_reported == undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.first_dealer_reported);
                    var fromField = g1;
                }
                else {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.locked_dealer_reported);
                    var fromField = g1;
                }
                if (params.data.left_dealer_marked == undefined) {
                    var c = new Date();
                    var todaydate = c;
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var toField = g2;
                }
                else {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                    var toField = g2;
                }
                var fstr = fromField.split("-");
                var gdate1 = new Date(fromField);
                var gdate2 = new Date(toField);
                var frmd = gdate1.getTime();
                var tod = gdate2.getTime();
                var total = tod - frmd;
                var diffMs = total;
                var diffDays = Math.floor(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                var dataarr = []
                let loadingTimeDifference = null;
                loadingTimeDifference = secondsToString(diffMs / 1000)
                dataarr.push({
                    "from_date": fromField,
                    "to_date": toField,
                    "unloading_time": loadingTimeDifference
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowNoGPSData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nogpscols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nogpsrecords = []
                redirectURL.post('/consignments/nogpsdata', {
                    consignment_code: params.data.consignment_code,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        nogpsrecords = response.data;
                        params.successCallback(nogpsrecords);

                    });
            },
        })
    }
    const fragmentData = (resp) => {
        console.log(resp, "uiconsignments1");
        if (resp.data.status == "success") {
            // setRowData(resp.data.consignments)
            console.log(resp.data.consignments, "uiconsignments");
            
            let active_trips = resp.data.consignments.filter(e => (e.consignment_status == "In Transit"  || e.consignment_status == "Out For Delivery" || e.consignment_status == 4))
            let completed_trips = resp.data.consignments.filter(e => (e.consignment_status == "Delivered" || e.consignment_status == 6 || e.consignment_status == 7))
            let active_transit_delay = []
            // let active_overspeeding = []
            // let active_night_driving = []
            let active_stoppages = []
            let active_accidents = []
            let active_trip_deviations = []
            let active_loadingdelay = []
            let active_unloadingdelay = []
            let active_no_gps_data = []
            let active_no_gps_data_lifetime = []
            let completed_transit_delay = []
            // let completed_overspeeding = []
            // let completed_night_driving = []
            let completed_stoppages = []
            let completed_accidents = []
            let completed_trip_deviations = []
            let completed_loadingdelay = []
            let completed_unloadingdelay = []
            let completed_no_gps_data = []
            let completed_no_gps_data_lifetime = []
            let transit_delay = []
            // let overspeeding = []
            // let night_driving = []
            let stoppages = []
            let accidents = []
            let trip_deviations = []
            let loading_delay = []
            let unloading_delay = []
            let no_gps_data = []
            let no_gps_data_lifetime = []
            active_trips.map(each => {
                if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                    active_transit_delay.push(each)
                }
                // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //     active_overspeeding.push(each)
                // }
                // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //     active_night_driving.push(each)
                // }
                if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                    active_stoppages.push(each)
                }
                if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                    active_accidents.push(each)
                }
                if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                    active_trip_deviations.push(each)
                }
                if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                    active_loadingdelay.push(each)
                }
                if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                    active_unloadingdelay.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                    active_no_gps_data.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                    active_no_gps_data_lifetime.push(each)
                }
            })
            completed_trips.map(each => {
                if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                    completed_transit_delay.push(each)
                }
                // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //     completed_overspeeding.push(each)
                // }
                // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //     completed_night_driving.push(each)
                // }
                if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                    completed_stoppages.push(each)
                }
                if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                    completed_accidents.push(each)
                }
                if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                    completed_trip_deviations.push(each)
                }
                if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                    completed_loadingdelay.push(each)
                }
                if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                    completed_unloadingdelay.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                    completed_no_gps_data.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                    completed_no_gps_data_lifetime.push(each)
                }
            })
            resp.data.consignments.map(each => {
                if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                    transit_delay.push(each)
                }
                // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //     overspeeding.push(each)
                // }
                // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //     night_driving.push(each)
                // }
                if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                    stoppages.push(each)
                }
                if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                    accidents.push(each)
                }
                if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                    trip_deviations.push(each)
                }
                if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                    loading_delay.push(each)
                }
                if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                    unloading_delay.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                    no_gps_data.push(each)
                }
                if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                    no_gps_data_lifetime.push(each)
                }
            })
            setCountersActive({
                consignments: active_trips.length,
                transit_delays: active_transit_delay.length,
                // overspeeding: active_overspeeding.length,
                // night_driving: active_night_driving.length,
                stoppages: active_stoppages.length,
                accidents: active_accidents.length,
                trip_deviations: active_trip_deviations.length,
                loading_delay: active_loadingdelay.length,
                unloading_delay: active_unloadingdelay.length,
                no_gps_data: active_no_gps_data.length,
                no_gps_data_lifetime: active_no_gps_data_lifetime.length
            })
            setCountersCompleted({
                consignments: completed_trips.length,
                transit_delays: completed_transit_delay.length,
                // overspeeding: completed_overspeeding.length,
                // night_driving: completed_night_driving.length,
                stoppages: completed_stoppages.length,
                accidents: completed_accidents.length,
                trip_deviations: completed_trip_deviations.length,
                loading_delay: completed_loadingdelay.length,
                unloading_delay: completed_unloadingdelay.length,
                no_gps_data: completed_no_gps_data.length,
                no_gps_data_lifetime: completed_no_gps_data_lifetime.length
            })
            setCountersAll({
                consignments: resp.data.consignments.length,
                transit_delays: transit_delay.length,
                // overspeeding: overspeeding.length,
                // night_driving: night_driving.length,
                stoppages: stoppages.length,
                accidents: accidents.length,
                trip_deviations: trip_deviations.length,
                loading_delay: loading_delay.length,
                unloading_delay: unloading_delay.length,
                no_gps_data: no_gps_data.length,
                no_gps_data_lifetime: no_gps_data_lifetime.length
            })
            setActiveTrips({
                all: active_trips,
                transit_delays: active_transit_delay,
                // overspeeding: active_overspeeding,
                // night_driving: active_night_driving,
                stoppages: active_stoppages,
                accidents: active_accidents,
                trip_deviations: active_trip_deviations,
                loading_delay: active_loadingdelay,
                unloading_delay: active_unloadingdelay,
                no_gps_data: active_no_gps_data,
                no_gps_data_lifetime: active_no_gps_data_lifetime
            })
            setCompletedTrips({
                all: completed_trips,
                transit_delays: completed_transit_delay,
                // overspeeding: completed_overspeeding,
                // night_driving: completed_night_driving,
                stoppages: completed_stoppages,
                accidents: completed_accidents,
                trip_deviations: completed_trip_deviations,
                loading_delay: completed_loadingdelay,
                unloading_delay: completed_unloadingdelay,
                no_gps_data: completed_no_gps_data,
                no_gps_data_lifetime: completed_no_gps_data_lifetime
            })
            setAllTrips({
                all: resp.data.consignments,
                transit_delays: transit_delay,
                // overspeeding: overspeeding,
                // night_driving: night_driving,
                stoppages: stoppages,
                accidents: accidents,
                trip_deviations: trip_deviations,
                loading_delay: loading_delay,
                unloading_delay: unloading_delay,
                no_gps_data: no_gps_data,
                no_gps_data_lifetime: no_gps_data_lifetime
            })
            if (window.location.pathname == "/activeconsignments") {
                setRowData(active_trips)
                setTabName(tabOptions[0])
            }
            else if (window.location.pathname == "/deliveredcourierconsignments") {
                setRowData(completed_trips)
                setTabName(tabOptions[1])
            }
            else if (window.location.pathname == "/courierconsignments") {
                setRowData(resp.data.consignments)
                setTabName(tabOptions[2])
            }
        }
    }

    const loadConsignmentsData = async () => {
        console.log("getconsignments")
        await redirectURL.post("consignments/getCourierLRConsignments")
            .then(resp => {
                // if (resp.data.status == "success") {
                //     // setRowData(resp.data.consignments)
                //     let active_trips = resp.data.consignments.filter(e => (e.status == 2 || e.status == 3 || e.status == 4))
                //     let completed_trips = resp.data.consignments.filter(e => (e.status == 5 || e.status == 6 || e.status == 7))
                //     let active_transit_delay = []
                //     let active_overspeeding = []
                //     let active_night_driving = []
                //     let active_stoppages = []
                //     let active_accidents = []
                //     let active_trip_deviations = []
                //     let active_loadingdelay = []
                //     let active_unloadingdelay = []
                //     let active_no_gps_data = []
                //     let active_no_gps_data_lifetime = []
                //     let completed_transit_delay = []
                //     let completed_overspeeding = []
                //     let completed_night_driving = []
                //     let completed_stoppages = []
                //     let completed_accidents = []
                //     let completed_trip_deviations = []
                //     let completed_loadingdelay = []
                //     let completed_unloadingdelay = []
                //     let completed_no_gps_data = []
                //     let completed_no_gps_data_lifetime = []
                //     let transit_delay = []
                //     let overspeeding = []
                //     let night_driving = []
                //     let stoppages = []
                //     let accidents = []
                //     let trip_deviations = []
                //     let loading_delay = []
                //     let unloading_delay = []
                //     let no_gps_data = []
                //     let no_gps_data_lifetime = []
                //     active_trips.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             active_transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             active_overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             active_night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             active_stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             active_accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             active_trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             active_loadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             active_unloadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             active_no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             active_no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     completed_trips.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             completed_transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             completed_overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             completed_night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             completed_stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             completed_accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             completed_trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             completed_loadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             completed_unloadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             completed_no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             completed_no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     resp.data.consignments.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             loading_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             unloading_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     setCountersActive({
                //         consignments: active_trips.length,
                //         transit_delays: active_transit_delay.length,
                //         overspeeding: active_overspeeding.length,
                //         night_driving: active_night_driving.length,
                //         stoppages: active_stoppages.length,
                //         accidents: active_accidents.length,
                //         trip_deviations: active_trip_deviations.length,
                //         loading_delay: active_loadingdelay.length,
                //         unloading_delay: active_unloadingdelay.length,
                //         no_gps_data: active_no_gps_data.length,
                //         no_gps_data_lifetime: active_no_gps_data_lifetime.length
                //     })
                //     setCountersCompleted({
                //         consignments: completed_trips.length,
                //         transit_delays: completed_transit_delay.length,
                //         overspeeding: completed_overspeeding.length,
                //         night_driving: completed_night_driving.length,
                //         stoppages: completed_stoppages.length,
                //         accidents: completed_accidents.length,
                //         trip_deviations: completed_trip_deviations.length,
                //         loading_delay: completed_loadingdelay.length,
                //         unloading_delay: completed_unloadingdelay.length,
                //         no_gps_data: completed_no_gps_data.length,
                //         no_gps_data_lifetime: completed_no_gps_data_lifetime.length
                //     })
                //     setCountersAll({
                //         consignments: resp.data.consignments.length,
                //         transit_delays: transit_delay.length,
                //         overspeeding: overspeeding.length,
                //         night_driving: night_driving.length,
                //         stoppages: stoppages.length,
                //         accidents: accidents.length,
                //         trip_deviations: trip_deviations.length,
                //         loading_delay: loading_delay.length,
                //         unloading_delay: unloading_delay.length,
                //         no_gps_data: no_gps_data.length,
                //         no_gps_data_lifetime: no_gps_data_lifetime.length
                //     })
                //     setActiveTrips({
                //         all: active_trips,
                //         transit_delays: active_transit_delay,
                //         overspeeding: active_overspeeding,
                //         night_driving: active_night_driving,
                //         stoppages: active_stoppages,
                //         accidents: active_accidents,
                //         trip_deviations: active_trip_deviations,
                //         loading_delay: active_loadingdelay,
                //         unloading_delay: active_unloadingdelay,
                //         no_gps_data: active_no_gps_data,
                //         no_gps_data_lifetime: active_no_gps_data_lifetime
                //     })
                //     setCompletedTrips({
                //         all: completed_trips,
                //         transit_delays: completed_transit_delay,
                //         overspeeding: completed_overspeeding,
                //         night_driving: completed_night_driving,
                //         stoppages: completed_stoppages,
                //         accidents: completed_accidents,
                //         trip_deviations: completed_trip_deviations,
                //         loading_delay: completed_loadingdelay,
                //         unloading_delay: completed_unloadingdelay,
                //         no_gps_data: completed_no_gps_data,
                //         no_gps_data_lifetime: completed_no_gps_data_lifetime
                //     })
                //     setAllTrips({
                //         all: resp.data.consignments,
                //         transit_delays: transit_delay,
                //         overspeeding: overspeeding,
                //         night_driving: night_driving,
                //         stoppages: stoppages,
                //         accidents: accidents,
                //         trip_deviations: trip_deviations,
                //         loading_delay: loading_delay,
                //         unloading_delay: unloading_delay,
                //         no_gps_data: no_gps_data,
                //         no_gps_data_lifetime: no_gps_data_lifetime
                //     })
                //     setRowData(active_trips)

                // }
                fragmentData(resp)
            })
            .catch(err => console.log(err))
    }
    const getTruckConsignments = async (e) => {
        e.preventDefault();
        let params = {
            searchtype: searchType?.value,
            searchnumber: searchValue
        }
        await redirectURL.post("consignments/getConsignments", params)
            .then(resp => {
                // if (resp.data.status == "success") {
                //     // setRowData(resp.data.consignments)
                //     if (resp.data.consignments.length > 0) {
                //         let active_trips = resp.data.consignments.filter(e => (e.status == 2 || e.status == 3 || e.status == 4))
                //         let completed_trips = resp.data.consignments.filter(e => (e.status == 5 || e.status == 6 || e.status == 7))
                //         let active_transit_delay = []
                //         let active_overspeeding = []
                //         let active_night_driving = []
                //         let active_stoppages = []
                //         let active_accidents = []
                //         let active_trip_deviations = []
                //         let active_loadingdelay = []
                //         let active_unloadingdelay = []
                //         let active_no_gps_data = []
                //         let active_no_gps_data_lifetime = []
                //         let completed_transit_delay = []
                //         let completed_overspeeding = []
                //         let completed_night_driving = []
                //         let completed_stoppages = []
                //         let completed_accidents = []
                //         let completed_trip_deviations = []
                //         let completed_loadingdelay = []
                //         let completed_unloadingdelay = []
                //         let completed_no_gps_data = []
                //         let completed_no_gps_data_lifetime = []
                //         let transit_delay = []
                //         let overspeeding = []
                //         let night_driving = []
                //         let stoppages = []
                //         let accidents = []
                //         let trip_deviations = []
                //         let loading_delay = []
                //         let unloading_delay = []
                //         let no_gps_data = []
                //         let no_gps_data_lifetime = []
                //         active_trips.map(each => {
                //             if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //                 active_transit_delay.push(each)
                //             }
                //             if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //                 active_overspeeding.push(each)
                //             }
                //             if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //                 active_night_driving.push(each)
                //             }
                //             if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //                 active_stoppages.push(each)
                //             }
                //             if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //                 active_accidents.push(each)
                //             }
                //             if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //                 active_trip_deviations.push(each)
                //             }
                //             if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //                 active_loadingdelay.push(each)
                //             }
                //             if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //                 active_unloadingdelay.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //                 active_no_gps_data.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //                 active_no_gps_data_lifetime.push(each)
                //             }
                //         })
                //         completed_trips.map(each => {
                //             if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //                 completed_transit_delay.push(each)
                //             }
                //             if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //                 completed_overspeeding.push(each)
                //             }
                //             if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //                 completed_night_driving.push(each)
                //             }
                //             if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //                 completed_stoppages.push(each)
                //             }
                //             if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //                 completed_accidents.push(each)
                //             }
                //             if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //                 completed_trip_deviations.push(each)
                //             }
                //             if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //                 completed_loadingdelay.push(each)
                //             }
                //             if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //                 completed_unloadingdelay.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //                 completed_no_gps_data.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //                 completed_no_gps_data_lifetime.push(each)
                //             }
                //         })
                //         resp.data.consignments.map(each => {
                //             if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //                 transit_delay.push(each)
                //             }
                //             if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //                 overspeeding.push(each)
                //             }
                //             if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //                 night_driving.push(each)
                //             }
                //             if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //                 stoppages.push(each)
                //             }
                //             if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //                 accidents.push(each)
                //             }
                //             if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //                 trip_deviations.push(each)
                //             }
                //             if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //                 loading_delay.push(each)
                //             }
                //             if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //                 unloading_delay.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //                 no_gps_data.push(each)
                //             }
                //             if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //                 no_gps_data_lifetime.push(each)
                //             }
                //         })
                //         setCountersActive({
                //             consignments: active_trips.length,
                //             transit_delays: active_transit_delay.length,
                //             overspeeding: active_overspeeding.length,
                //             night_driving: active_night_driving.length,
                //             stoppages: active_stoppages.length,
                //             accidents: active_accidents.length,
                //             trip_deviations: active_trip_deviations.length,
                //             loading_delay: active_loadingdelay.length,
                //             unloading_delay: active_unloadingdelay.length,
                //             no_gps_data: active_no_gps_data.length,
                //             no_gps_data_lifetime: active_no_gps_data_lifetime.length
                //         })
                //         setCountersCompleted({
                //             consignments: completed_trips.length,
                //             transit_delays: completed_transit_delay.length,
                //             overspeeding: completed_overspeeding.length,
                //             night_driving: completed_night_driving.length,
                //             stoppages: completed_stoppages.length,
                //             accidents: completed_accidents.length,
                //             trip_deviations: completed_trip_deviations.length,
                //             loading_delay: completed_loadingdelay.length,
                //             unloading_delay: completed_unloadingdelay.length,
                //             no_gps_data: completed_no_gps_data.length,
                //             no_gps_data_lifetime: completed_no_gps_data_lifetime.length
                //         })
                //         setCountersAll({
                //             consignments: resp.data.consignments.length,
                //             transit_delays: transit_delay.length,
                //             overspeeding: overspeeding.length,
                //             night_driving: night_driving.length,
                //             stoppages: stoppages.length,
                //             accidents: accidents.length,
                //             trip_deviations: trip_deviations.length,
                //             loading_delay: loading_delay.length,
                //             unloading_delay: unloading_delay.length,
                //             no_gps_data: no_gps_data.length,
                //             no_gps_data_lifetime: no_gps_data_lifetime.length
                //         })
                //         setActiveTrips({
                //             all: active_trips,
                //             transit_delays: active_transit_delay,
                //             overspeeding: active_overspeeding,
                //             night_driving: active_night_driving,
                //             stoppages: active_stoppages,
                //             accidents: active_accidents,
                //             trip_deviations: active_trip_deviations,
                //             loading_delay: active_loadingdelay,
                //             unloading_delay: active_unloadingdelay,
                //             no_gps_data: active_no_gps_data,
                //             no_gps_data_lifetime: active_no_gps_data_lifetime
                //         })
                //         setCompletedTrips({
                //             all: completed_trips,
                //             transit_delays: completed_transit_delay,
                //             overspeeding: completed_overspeeding,
                //             night_driving: completed_night_driving,
                //             stoppages: completed_stoppages,
                //             accidents: completed_accidents,
                //             trip_deviations: completed_trip_deviations,
                //             loading_delay: completed_loadingdelay,
                //             unloading_delay: completed_unloadingdelay,
                //             no_gps_data: completed_no_gps_data,
                //             no_gps_data_lifetime: completed_no_gps_data_lifetime
                //         })
                //         setAllTrips({
                //             all: resp.data.consignments,
                //             transit_delays: transit_delay,
                //             overspeeding: overspeeding,
                //             night_driving: night_driving,
                //             stoppages: stoppages,
                //             accidents: accidents,
                //             trip_deviations: trip_deviations,
                //             loading_delay: loading_delay,
                //             unloading_delay: unloading_delay,
                //             no_gps_data: no_gps_data,
                //             no_gps_data_lifetime: no_gps_data_lifetime
                //         })
                //         setRowData(active_trips)
                //     }
                // }
                fragmentData(resp)
            })
            .catch(err => console.log(err))
    }
    const saveConsignments = async (e) => {
        e.preventDefault();
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                if (node.data.plant_code == "" || node.data.fo_number == "" || node.data.order_number == "" || node.data.invoice_date == "" || node.data.transporter_code == "" || node.data.dealer_code == "" || node.data.quantity == "" || node.data.execution_date == "" || node.data.expected_date == "" || node.data.expected_return_to_plant_date == "" || node.data.plant_code == undefined || node.data.fo_number == undefined || node.data.order_number == undefined || node.data.invoice_date == undefined || node.data.transporter_code == undefined || node.data.dealer_code == undefined || node.data.quantity == undefined || node.data.execution_date == undefined || node.data.expected_date == undefined || node.data.expected_return_to_plant_date == undefined) {
                    setShow(true)
                    setTitle("Please fill the required fields")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!plantData.some(e => e.consigner_code == node.data.plant_code)) {
                    setShow(true)
                    setTitle("Please give a valid Plant Code")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if ((!moment(node.data.invoice_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
                    setShow(true)
                    setTitle("Please give a valid Invoice Date (YYYY-MM-DD HH:mm:ss)")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!transporters.some(e => e.transporter_code == node.data.transporter_code)) {
                    setShow(true)
                    setTitle("Please give a valid Plant Code")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!dealers.some(e => e.consignee_code == node.data.dealer_code)) {
                    setShow(true)
                    setTitle("Please give a valid Dealer Code")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (isNaN(node.data.quantity)) {
                    setShow(true)
                    setTitle("Please give a valid quantity")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!moment(node.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                    setShow(true)
                    setTitle("Please give a valid Execution Date (YYYY-MM-DD HH:mm:ss)")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!moment(node.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                    setShow(true)
                    setTitle("Please give a valid Expected Date (YYYY-MM-DD HH:mm:ss)")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!moment(node.data.expected_return_to_plant_date, "YYYY-MM-DD HH:mm:ss").isValid()) {
                    setShow(true)
                    setTitle("Please give a valid Expected Return to Plant Date (YYYY-MM-DD HH:mm:ss)")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (previousData.some(e => ((e.order_number == node.data.order_number) && (e.fo_number == node.data.fo_number)))) {
                    setShow(true)
                    setTitle("Order number and FO number combination already exist for previous consignments")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else
                    gridRowData.push(node.data)
            })
            if (gridRowData.length > 0) {
                await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: "" })
                    .then(response => {
                        if (response.data.status == "success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            loadConsignmentsData()
                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                        }
                    })
                    .catch(err => console.log(err))
            }
        }
    }
    const onConfirm = () => {
        setShow(false);
        setLoader(false)
        if (reloadPage.current) {
            window.location.reload()
        }
    };

    const onGetConsignments = async (event) => {
        let query = {}
        if (searchCity.value != '')
            query["consignee_city"] = searchCity.value
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["sdate"] = startDate
        }
        if (endDate == '' || startDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = endDate
        }
        if (searchConsigner == null || searchConsigner[0]?.value == '' || searchConsigner[0]?.value == 'all') {
        }
        else {
            query["consigner_code"] = searchConsigner.map(e => e.value)
        }
        if (searchState.value != '') {
            query["consignee_state"] = searchState.value
        }
        if (searchTransporters.value != "") {
            query["transporter_name"] = searchTransporters.value
        }
        await redirectURL.post("consignments/filterConsignments", query)
            .then(resp => {
                // if (resp.data.status == "success") {
                //     let active_trips = resp.data.consignments.filter(e => (e.status == 2 || e.status == 3 || e.status == 4))
                //     let completed_trips = resp.data.consignments.filter(e => (e.status == 5 || e.status == 6 || e.status == 7))
                //     let active_transit_delay = []
                //     let active_overspeeding = []
                //     let active_night_driving = []
                //     let active_stoppages = []
                //     let active_accidents = []
                //     let active_trip_deviations = []
                //     let active_loadingdelay = []
                //     let active_unloadingdelay = []
                //     let active_no_gps_data = []
                //     let active_no_gps_data_lifetime = []
                //     let completed_transit_delay = []
                //     let completed_overspeeding = []
                //     let completed_night_driving = []
                //     let completed_stoppages = []
                //     let completed_accidents = []
                //     let completed_trip_deviations = []
                //     let completed_loadingdelay = []
                //     let completed_unloadingdelay = []
                //     let completed_no_gps_data = []
                //     let completed_no_gps_data_lifetime = []
                //     let transit_delay = []
                //     let overspeeding = []
                //     let night_driving = []
                //     let stoppages = []
                //     let accidents = []
                //     let trip_deviations = []
                //     let loading_delay = []
                //     let unloading_delay = []
                //     let no_gps_data = []
                //     let no_gps_data_lifetime = []
                //     active_trips.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             active_transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             active_overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             active_night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             active_stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             active_accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             active_trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             active_loadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             active_unloadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             active_no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             active_no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     completed_trips.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             completed_transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             completed_overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             completed_night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             completed_stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             completed_accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             completed_trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             completed_loadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             completed_unloadingdelay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             completed_no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             completed_no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     resp.data.consignments.map(each => {
                //         if (each.hasOwnProperty("transit_delay") && each.transit_delay > 0) {
                //             transit_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                //             overspeeding.push(each)
                //         }
                //         if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                //             night_driving.push(each)
                //         }
                //         if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                //             stoppages.push(each)
                //         }
                //         if (each.hasOwnProperty("accident_exception") && each.accident_exception == 1) {
                //             accidents.push(each)
                //         }
                //         if (each.hasOwnProperty("tpt_deviation_status") && each.tpt_deviation_status == 1) {
                //             trip_deviations.push(each)
                //         }
                //         if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                //             loading_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                //             unloading_delay.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 1) {
                //             no_gps_data.push(each)
                //         }
                //         if (each.hasOwnProperty("no_gps_data") && each.no_gps_data == 0) {
                //             no_gps_data_lifetime.push(each)
                //         }
                //     })
                //     setCountersActive({
                //         consignments: active_trips.length,
                //         transit_delays: active_transit_delay.length,
                //         overspeeding: active_overspeeding.length,
                //         night_driving: active_night_driving.length,
                //         stoppages: active_stoppages.length,
                //         accidents: active_accidents.length,
                //         trip_deviations: active_trip_deviations.length,
                //         loading_delay: active_loadingdelay.length,
                //         unloading_delay: active_unloadingdelay.length,
                //         no_gps_data: active_no_gps_data.length,
                //         no_gps_data_lifetime: active_no_gps_data_lifetime.length
                //     })
                //     setCountersCompleted({
                //         consignments: completed_trips.length,
                //         transit_delays: completed_transit_delay.length,
                //         overspeeding: completed_overspeeding.length,
                //         night_driving: completed_night_driving.length,
                //         stoppages: completed_stoppages.length,
                //         accidents: completed_accidents.length,
                //         trip_deviations: completed_trip_deviations.length,
                //         loading_delay: completed_loadingdelay.length,
                //         unloading_delay: completed_unloadingdelay.length,
                //         no_gps_data: completed_no_gps_data.length,
                //         no_gps_data_lifetime: completed_no_gps_data_lifetime.length
                //     })
                //     setCountersAll({
                //         consignments: resp.data.consignments.length,
                //         transit_delays: transit_delay.length,
                //         overspeeding: overspeeding.length,
                //         night_driving: night_driving.length,
                //         stoppages: stoppages.length,
                //         accidents: accidents.length,
                //         trip_deviations: trip_deviations.length,
                //         loading_delay: loading_delay.length,
                //         unloading_delay: unloading_delay.length,
                //         no_gps_data: no_gps_data.length,
                //         no_gps_data_lifetime: no_gps_data_lifetime.length
                //     })
                //     setActiveTrips({
                //         all: active_trips,
                //         transit_delays: active_transit_delay,
                //         overspeeding: active_overspeeding,
                //         night_driving: active_night_driving,
                //         stoppages: active_stoppages,
                //         accidents: active_accidents,
                //         trip_deviations: active_trip_deviations,
                //         loading_delay: active_loadingdelay,
                //         unloading_delay: active_unloadingdelay,
                //         no_gps_data: active_no_gps_data,
                //         no_gps_data_lifetime: active_no_gps_data_lifetime
                //     })
                //     setCompletedTrips({
                //         all: completed_trips,
                //         transit_delays: completed_transit_delay,
                //         overspeeding: completed_overspeeding,
                //         night_driving: completed_night_driving,
                //         stoppages: completed_stoppages,
                //         accidents: completed_accidents,
                //         trip_deviations: completed_trip_deviations,
                //         loading_delay: completed_loadingdelay,
                //         unloading_delay: completed_unloadingdelay,
                //         no_gps_data: completed_no_gps_data,
                //         no_gps_data_lifetime: completed_no_gps_data_lifetime
                //     })
                //     setAllTrips({
                //         all: resp.data.consignments,
                //         transit_delays: transit_delay,
                //         overspeeding: overspeeding,
                //         night_driving: night_driving,
                //         stoppages: stoppages,
                //         accidents: accidents,
                //         trip_deviations: trip_deviations,
                //         loading_delay: loading_delay,
                //         unloading_delay: unloading_delay,
                //         no_gps_data: no_gps_data,
                //         no_gps_data_lifetime: no_gps_data_lifetime
                //     })
                //     setRowData(active_trips)

                // }
                fragmentData(resp)
            })
            .catch(err => console.log(err))
    }
    const onClickShowForm=()=> {
        setOverlay("show-m")
        setSliderCreateConsignmentTranslate("slider-translate-30p")
	}
    const changeHandler = (event) => {
        const { name, value } = event.target;
        if (name === "driver_mobile_num" || name === "transit_days") {
            if (value !== "" && value !== undefined) {
                if (value > 0) {
                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value.replace(/\D/g, '')
                    }));
                }
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value.replace(/\D/g, '')
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    // const onClickHideAll=()=> {
	// 	var uploadfilebulk = $("#uploadfile").val(null)
	// 	this.setState({
	// 		loadshow: 'show-n',
	// 		overly: 'show-n',
	// 		slideuploadeway: '',
	// 		sliderRouteTranslate: '',
	// 		sliderSegmentTranslate: "",
	// 		tabsliderTranslate: '',
	// 		sliderTranslatesidebar: '',
	// 		sliderForceCloseTranslate: '',
	// 		sliderChangeDriverDetails:'',
	// 		sliderCommentTranslate: "",
	// 		bulkPrioritySlide: "",
	// 		sliderCreateConsignmentTranslate: "",
	// 		sliderRso:"",
	// 		sliderSimConsent:"",
	// 		uploadfilebulk:uploadfilebulk
	// 	});

	// }
    const onGridReady = useCallback((params) => {
        gridApi.current = params.api
    }, []);

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const onClickHideManualUpload = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails((prev) => ({
          ...prev,
          lr_no: "",
          consignee_name: "",
          invoice_no: "",
          no_of_boxes: "",
          destination_pincode: "",
          destination_city: "",
        }));
      };

    var filterClassName = "form-group col-xl-12 col-lg-12";
    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={formForceCloseHandler}>
                            <div className="col-xl-12 col-lg-12">
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Force Close
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForceClose}
                                    onChange={e => setReasonForceClose(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            
            {/* <div className="d-flex flex-row justify-content-between ml-4 mt-2p">

            <div className="">
                    <ul className={"nav nav-tabs"}>
                        <li className={"nav-item"}>
                            <a
                                // className={`nav-link ${tabActive == "BL/Booking" ? "tab-active" : ""
                                //     }`}
                                className={`nav-link ${tabActive == "ftl" ? "tab-active" : ""
                            }`}

                                aria-current="page"
                                // onClick={() => settabActive("BL/Booking")}
                                onClick={()=> settabActive('ftl')}
                                style={{
                                    borderTop: "none",
                                    borderLeft: "none",
                                    borderRight: "none",
                                }}
                            >
                                FTL
                            </a>
                        </li>
                        <li className={"nav-item"}>
                            <a
                                className={`nav-link ${tabActive == "PTL" ? "tab-active" : ""
                                    }`}
                                onClick={() => { settabActive("PTL"); 
                                    // showSubcounters('1') 
                                }}
                                style={{
                                    borderTop: "none",
                                    borderLeft: "none",
                                    borderRight: "none",
                                }}
                            >
                                PTL
                            </a>
                        </li>
                    </ul>
                </div>
            </div> */}
               <div className="row" >
                <div className="col-xl-12 col-lg-12">
                <div className="card">
  <div className="card-header d-flex">
    <div
      onClick={() => { setTabName(tabOptions[0]); setRowData(activeTrips.all) }}
      className={`mr-10p p-10p dashboard1 ${tabName.value === "active" ? "activetab" : "inactivetab"}`}
    >
      <h5>Active</h5>
    </div>
    <div
      onClick={() => { setTabName(tabOptions[1]); setRowData(completedTrips.all) }}
      className={`mr-10p p-10p dashboard1 ${tabName.value === "completed" ? "activetab" : "inactivetab"}`}
    >
      <h5>Delivered</h5>
    </div>
    <div
      onClick={() => { setTabName(tabOptions[2]); setRowData(allTrips.all) }}
      className={`p-10p dashboard1 ${tabName.value === "all" ? "activetab" : "inactivetab"}`}
    >
      <h5>All</h5>
    </div>
  </div>
</div>

                   

                
                    {/* <button
                        // onClick={this.reloadPageData.bind(this)}
                        className={"btn btn-info"}
                        style={{ float: "right" }}>
                        Reset Filters
                    </button> */}
                    {/* <button type="button" className="btn btn-warning float-right ml-20p" onClick={onClickShowForm}>Add Consignment</button> */}

                    {/* <i className='fa fa-filter mx-2' onClick={(e) => setFilterToggle(prev => !prev)} style={{ cursor: "pointer", float: "right", fontSize: "2rem" }} /> */}
                </div>
            </div>


            <div className={filterToggle ? "filter-in" : "filter-out"}>
                {
                    filterToggle &&
                    <div className={filterToggle ? "row" : "row"}>
                        <div className={"col-xl-4 col-lg-4 "}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={{ padding: "10px 30px" }}>
                                    <form className="row" onSubmit={getTruckConsignments}>
                                        <div className={filterClassName}>
                                            <label>Select Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchType}
                                                onChange={e => setSearchType(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={[
                                                    { label: "Vehicle", value: "truck_no" },
                                                    { label: "Consignments", value: "consignment_code" },
                                                ]} required />
                                        </div>
                                        <div className={filterClassName}>
                                            <label className="reason">Vehicle / Consignment No</label>
                                            <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={searchValue} onChange={e => setSeachValue(e.target.value)} />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12" style={{ textAlign: "left" }}>
                                            <button type="submit" className="btn btn-success">Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xl-8 col-lg-8"}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={filterCardStyle2}>
                                    <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Select Consigner </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={searchConsigner}
                                                isMulti={true}
                                                className="border-radius-0"
                                                onChange={e => setSearchConsigner(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={consignersList}
                                                required />

                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"><label>From Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={handleStartDateChange}
                                                    name="startDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"> <label>To Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={handleEndDateChange}
                                                    name="endDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignment City   </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedCity"
                                                style={{ borderRadius: "0px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignment State</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedState"
                                                style={{ borderRadius: "0px" }}
                                                value={searchState}
                                                onChange={e => setSearchStates(e)}
                                                options={filterStates}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Transporter  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedTransporter"
                                                style={{ borderRadius: "0px" }}
                                                value={searchTransporters}
                                                onChange={(e) => setSearchTransporters(e)}
                                                options={filterTransporters}
                                            />
                                        </div>
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px" }}>
                                        <button type="button" className="btn btn-success" onClick={onGetConsignments}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
          
            {
                <div className={""}>
                    <MainCounters setCounter={CounterClick} data={tabName.value == "active" ? countersActive : (tabName.value == "completed" ? countersCompleted : countersAll)} tabName={tabName} />
                </div>
            }
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <h5>
                                <i className="icofont icofont-vehicle-delivery-van cus-i ml-30p"></i> <span>{`${tabName?.label} - ${counter?.label}`}</span>
                            </h5>
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 mb-10p">
                                    <span className="float-right" style={{ fontSize: "13px", fontWeight: "100" }}>
                                        <i className="icofont icofont-clock-time" style={{ color: "#ff0000", fontSize: "22px	" }}></i> - Transit Delays
                                        |&nbsp;<i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "22px" }}></i> - GPS Not Available
                                        {/* |&nbsp; */}
                                        {/* <i className="icofont icofont-social-google-map txt-secondary" style={{ fontSize: "22px" }}></i> - GPS Data Not Adequate */}
                                        {/* |&nbsp; */}
                                        {/* <span>
                                            <i className="fa fa-tachometer darkblue" style={{ fontSize: "22px" }}></i> - Overspeeding
                                        </span>|
                                        <span>
                                            <span>&nbsp;<i className="icofont icofont-full-night txt-primary" style={{ fontSize: "22px" }}></i> - Night Driving
                                            </span>
                                            <span>|&nbsp;<i className="icofont icofont-truck-alt darkorange" style={{ fontSize: "22px" }}></i> - Loading Delay
                                            </span>
                                            {
                                                tabName?.value == "completed" || tabName?.value == "all" ?
                                                    <span>|&nbsp;<i className="icofont icofont-vehicle-delivery-van mildgreen" style={{ fontSize: "22px" }}></i> - Unloading Delay
                                                    </span> :
                                                    <></>
                                            }
                                        </span> */}
                                        |&nbsp;<i className="icofont icofont-pause maroon" style={{ fontSize: "22px" }}></i> - Stoppages
                                        <span>
                                            {/* |&nbsp; */}
                                            {/* <i className="icofont icofont-barricade txt-danger" style={{ fontSize: "22px" }}></i> - Probable Accident */}
                                        </span>
                                    </span>

                                </div>

                                <div className={"col-xl-12 mb-10p "}>
                                    <span className="layoutbtns">
                                        <button className="float-right custom-btn white btn-danger"
                                            // onClick={this.onClickSaveGridState}
                                            onClick={saveGrid}
                                        >
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{ marginRight: "10px" }}
                                            // onClick={this.resetState}
                                            onClick={resetGrid}
                                        >
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                        {/* <div className="float-right">
                                            <button
                                                title="Bulk Upload"
                                                onClick={onClickOpenBulkUploadModal}
                                                className={"float-right custom-btn white btn-danger mr-2"}
                                                type="button">
                                                <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                                            </button>
                                        </div> */}
                                    </span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-body pt-10px" >
                          
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    columnDefs={columnwithDefs}
                                    rowData={rowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    onGridReady={onGridReadyConsignments}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    detailCellRendererParams={detailCellRendererParams}
                                    // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                    // context={{
                                        
                                    //     onClickActive
                                    //   }}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openMap.sliderRouteTranslate != '' ?
                <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                    <div className="slide-r-title">
                        <h4>
                            {(openMap.consignment_code)}
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                            <DrawMap
                                rownode={openMap.rownode}
                                mapFor={"consignment"}
                                tolls={openMap.tolls}
                                googleroutes={openMap.googelRoutes}
                                truckno={openMap.maptruckno}
                                dealer={openMap.dealer}
                                mapinfo={openMap.mapinfo}
                                deptcode={openMap.deptcode}
                                defTransitCoords={openMap.defTransitCoords}
                                baseRouteCoords={openMap.baseRouteCoords}
                                geofence_coordinates={openMap.geofence_coordinates}
                                parking_coordinates={openMap.parking_coordinates}
                            />
                            <div className="col-xl-12 col-lg-12 n-p-0">
                                <div className="crm-numbers pb-0">
                                    <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                    <div className="col-xl-12 col-lg-12 row">
                                        <div className="col route-block">
                                            <label className="sidebar-label">Truck No</label>
                                            <div>{openMap.routeTruck.truck_no}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">Start Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">End Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                        </div>

                                        <div className="col route-block">
                                            <label className="sidebar-label">GPS Distance</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                : ""
            }
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>

                    <div className="container-fluid">
                        <form method="POST" id="upform" className="theme-form">
                            <div className="col-xl-6 col-lg-6 form-group">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" required />
                            </div>
                        </form>
                        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div className="form-group">
                                {/* <a className="btn btn-primary" href={require('../../assets/files/Nestle Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a> */}
                            </div>
                            <div className='form-group' style={{ marginRight: "8px" }}>
                                <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>
                            </div>
                        </div>
                        <div className="ag-theme-balham mt-2" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={columnDef}
                                rowData={modalloadData}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <div className={"slide-r " + (sliderCreateConsignmentTranslate)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4>
							Add Consignment
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={onClickHideAll} >X</span>

						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>

						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div>
						<div className={"row"} style={{ padding: '5px 0px', width: '100%', overflow: 'hidden', zIndex: '9999', height: "100em" }} >
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Enter Truck<span style={{color:'red'}}>*</span> </label>

									{/* <Select
										placeholder={"Select Truck"}
										closeMenuOnSelect={true}
										onChange={this.onChangeTruckItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="truck_no"
										value={this.state.truck_no}
										options={this.state.trucklist} /> */}
									<input
										// placeholder={"Enter Truck No"}
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.truck_no}
										name="truck_no"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">GR No/Consignment Code<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.grno_consignment_code}
										name="grno_consignment_code"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Invoice No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.invoice_no}
										name="invoice_no"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Invoice Date<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control datetimepicker_mask ml-3"
										id="invoice_date"
										name="invoice_date"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Trip Started On<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control datetimepicker_mask ml-3"
										id="gate_out_time"
										name="gate_out_time"
										autoComplete='off'
									/>
								</div>
								
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Transit Days<span style={{color:'red'}}>*</span>  </label>
									<input
										type="number"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.transit_days}
										name="transit_days"
										autoComplete='off'
									/>
								</div>

								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Select Plant<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Plant"}
										closeMenuOnSelect={true}
										// onChange={this.onChangePlantItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="plant_code"
										// value={this.state.plant_code}
										// options={this.state.plantlist}
                                         />
								</div>

								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Dealer Code<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Dealer Code"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeConsigneeItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="consignee_code"
										// value={this.state.consignee_code}
										// options={this.state.consignees}
                                         />
								</div>
								{/* {(transporteCode)?
									<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Name </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_name}
										name="driver_name"
										autoComplete='off'
									/>
								</div>
								:
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Name<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_name}
										name="driver_name"
										autoComplete='off'
									/>
								</div>
								} */}
								{/* {(transporteCode)?
								<div className="col-xl-12 col-lg-12 row form-group">
								<label className="col-xl-12 col-lg-12">Driver Mobile No </label>
								<input
									type="text"
									className="form-control ml-3"
									onChange={this.changeHandler}
									value={this.state.driver_mobile_num}
									name="driver_mobile_num"
									autoComplete='off'
								/>
							</div>
								:
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Mobile No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_mobile_num}
										name="driver_mobile_num"
										autoComplete='off'
									/>
								</div>
								} */}
								
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Mobile Operator<span style={{color:'red'}}>*</span>  </label>
									<Select
										placeholder={"Select Mobile Operator"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeDriverMobileOperator.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="driverMobileOperator"
										// value={this.state.mobile_operator}
										// options={this.state.mobileOperatorData} 
										required
										/>
									
								</div>
								
								{(localStorage.getItem("user_type")=="TRANSPORTER")?"":
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Transporter Name<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Transporter Name"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeTransporterItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="transporter_code"
										// value={this.state.transporter_code}
										// options={this.state.transportersdata} 
                                        />
								</div>
								}
								<div className="col-xl-12 col-lg-12 form-group">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
							</form>
						</div>
					</div>
				</div>
                <div
        className={"slide-r " + showAddForm}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Add Dealer<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload} >X</span></h4>
          

        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            // onSubmit={onsubmitdata}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      LR No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.lr_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Consignee Name<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.consignee_name}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, consignee_name: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Invoice No.<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.invoice_no}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, invoice_no: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Number Of Boxes<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.no_of_boxes}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, no_of_boxes: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination Pincode<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.destination_pincode}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_pincode: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Destination City<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                                            type="text"
                                            name="lr_no"
                                            id="lr_no"
                                            value={manualUploadDetails.destination_city}
                                            className="form-control"
                                            onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, destination_city: e.target.value }))}
                                            required
                                        /> 
                 
                  </div>
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>    
            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                onClick={onClickHideAll}
            ></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div >
    );
}

export default Consignments;

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}

function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
} 
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
		// console.log(date1,date2);
		var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
		date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
		var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
		date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
		// console.log(date1,date2);
		var date1Number = monthToComparableNumber(date1);
		var date2Number = monthToComparableNumber(date2);
		// console.log(date1Number,date2Number);
		if (date1Number === null && date2Number === null) {
			return 0;
		}
		if (date1Number === null) {
			return -1;
		}
		if (date2Number === null) {
			return 1;
		}
		return date1Number - date2Number;
	}
}
function getMonthNumber(monthName) {
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
	];
	var monthNum = months.indexOf(monthName) + 1;
	if (monthNum < 10) {
		monthNum = "0" + monthNum.toString();
	}
	return monthNum;
}
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	//console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
